// generated by Copilot and not reviewed line by line

package com.huanshankeji.compose.material.icons.filled

import com.huanshankeji.compose.material.icons.Icon
import com.huanshankeji.compose.material.icons.Icons

actual val Icons.Filled.Abc: Icon get() = Icon("abc")
actual val Icons.Filled.AcUnit: Icon get() = Icon("ac_unit")
actual val Icons.Filled.Accessibility: Icon get() = Icon("accessibility")
actual val Icons.Filled.AccessibilityNew: Icon get() = Icon("accessibility_new")
actual val Icons.Filled.Accessible: Icon get() = Icon("accessible")
actual val Icons.Filled.AccessibleForward: Icon get() = Icon("accessible_forward")
actual val Icons.Filled.AccountBalance: Icon get() = Icon("account_balance")
actual val Icons.Filled.AccountBalanceWallet: Icon get() = Icon("account_balance_wallet")
actual val Icons.Filled.AccountTree: Icon get() = Icon("account_tree")
actual val Icons.Filled.Adb: Icon get() = Icon("adb")
actual val Icons.Filled.AddAPhoto: Icon get() = Icon("add_a_photo")
actual val Icons.Filled.AddAlert: Icon get() = Icon("add_alert")
actual val Icons.Filled.AddBox: Icon get() = Icon("add_box")
actual val Icons.Filled.AddBusiness: Icon get() = Icon("add_business")
actual val Icons.Filled.AddCard: Icon get() = Icon("add_card")
actual val Icons.Filled.AddChart: Icon get() = Icon("add_chart")
actual val Icons.Filled.AddComment: Icon get() = Icon("add_comment")
actual val Icons.Filled.AddHome: Icon get() = Icon("add_home")
actual val Icons.Filled.AddHomeWork: Icon get() = Icon("add_home_work")
actual val Icons.Filled.AddLink: Icon get() = Icon("add_link")
actual val Icons.Filled.AddLocation: Icon get() = Icon("add_location")
actual val Icons.Filled.AddLocationAlt: Icon get() = Icon("add_location_alt")
actual val Icons.Filled.AddModerator: Icon get() = Icon("add_moderator")
actual val Icons.Filled.AddPhotoAlternate: Icon get() = Icon("add_photo_alternate")
actual val Icons.Filled.AddReaction: Icon get() = Icon("add_reaction")
actual val Icons.Filled.AddRoad: Icon get() = Icon("add_road")
actual val Icons.Filled.AddShoppingCart: Icon get() = Icon("add_shopping_cart")
actual val Icons.Filled.AddTask: Icon get() = Icon("add_task")
actual val Icons.Filled.AddToDrive: Icon get() = Icon("add_to_drive")
actual val Icons.Filled.AddToPhotos: Icon get() = Icon("add_to_photos")
actual val Icons.Filled.AddToQueue: Icon get() = Icon("add_to_queue")
actual val Icons.Filled.AdfScanner: Icon get() = Icon("adf_scanner")
actual val Icons.Filled.Adjust: Icon get() = Icon("adjust")
actual val Icons.Filled.AdminPanelSettings: Icon get() = Icon("admin_panel_settings")
actual val Icons.Filled.AdsClick: Icon get() = Icon("ads_click")
actual val Icons.Filled.Agriculture: Icon get() = Icon("agriculture")
actual val Icons.Filled.Air: Icon get() = Icon("air")
actual val Icons.Filled.AirlineSeatFlat: Icon get() = Icon("airline_seat_flat")
actual val Icons.Filled.AirlineSeatFlatAngled: Icon get() = Icon("airline_seat_flat_angled")
actual val Icons.Filled.AirlineSeatIndividualSuite: Icon get() = Icon("airline_seat_individual_suite")
actual val Icons.Filled.AirlineSeatLegroomExtra: Icon get() = Icon("airline_seat_legroom_extra")
actual val Icons.Filled.AirlineSeatLegroomNormal: Icon get() = Icon("airline_seat_legroom_normal")
actual val Icons.Filled.AirlineSeatLegroomReduced: Icon get() = Icon("airline_seat_legroom_reduced")
actual val Icons.Filled.AirlineSeatReclineExtra: Icon get() = Icon("airline_seat_recline_extra")
actual val Icons.Filled.AirlineSeatReclineNormal: Icon get() = Icon("airline_seat_recline_normal")
actual val Icons.Filled.AirlineStops: Icon get() = Icon("airline_stops")
actual val Icons.Filled.Airlines: Icon get() = Icon("airlines")
actual val Icons.Filled.AirplaneTicket: Icon get() = Icon("airplane_ticket")
actual val Icons.Filled.AirplanemodeActive: Icon get() = Icon("airplanemode_active")
actual val Icons.Filled.AirplanemodeInactive: Icon get() = Icon("airplanemode_inactive")
actual val Icons.Filled.Airplay: Icon get() = Icon("airplay")
actual val Icons.Filled.AirportShuttle: Icon get() = Icon("airport_shuttle")
actual val Icons.Filled.Alarm: Icon get() = Icon("alarm")
actual val Icons.Filled.AlarmAdd: Icon get() = Icon("alarm_add")
actual val Icons.Filled.AlarmOff: Icon get() = Icon("alarm_off")
actual val Icons.Filled.AlarmOn: Icon get() = Icon("alarm_on")
actual val Icons.Filled.Album: Icon get() = Icon("album")
actual val Icons.Filled.AlignHorizontalCenter: Icon get() = Icon("align_horizontal_center")
actual val Icons.Filled.AlignHorizontalLeft: Icon get() = Icon("align_horizontal_left")
actual val Icons.Filled.AlignHorizontalRight: Icon get() = Icon("align_horizontal_right")
actual val Icons.Filled.AlignVerticalBottom: Icon get() = Icon("align_vertical_bottom")
actual val Icons.Filled.AlignVerticalCenter: Icon get() = Icon("align_vertical_center")
actual val Icons.Filled.AlignVerticalTop: Icon get() = Icon("align_vertical_top")
actual val Icons.Filled.AllInbox: Icon get() = Icon("all_inbox")
actual val Icons.Filled.AllInclusive: Icon get() = Icon("all_inclusive")
actual val Icons.Filled.AllOut: Icon get() = Icon("all_out")
actual val Icons.Filled.AltRoute: Icon get() = Icon("alt_route")
actual val Icons.Filled.AlternateEmail: Icon get() = Icon("alternate_email")
actual val Icons.Filled.AmpStories: Icon get() = Icon("amp_stories")
actual val Icons.Filled.Analytics: Icon get() = Icon("analytics")
actual val Icons.Filled.Anchor: Icon get() = Icon("anchor")
actual val Icons.Filled.Android: Icon get() = Icon("android")
actual val Icons.Filled.Animation: Icon get() = Icon("animation")
actual val Icons.Filled.Apartment: Icon get() = Icon("apartment")
actual val Icons.Filled.Api: Icon get() = Icon("api")
actual val Icons.Filled.AppRegistration: Icon get() = Icon("app_registration")
actual val Icons.Filled.Approval: Icon get() = Icon("approval")
actual val Icons.Filled.Apps: Icon get() = Icon("apps")
actual val Icons.Filled.AppsOutage: Icon get() = Icon("apps_outage")
actual val Icons.Filled.Architecture: Icon get() = Icon("architecture")
actual val Icons.Filled.Archive: Icon get() = Icon("archive")
actual val Icons.Filled.AreaChart: Icon get() = Icon("area_chart")
actual val Icons.Filled.ArrowBackIos: Icon get() = Icon("arrow_back_ios")
actual val Icons.Filled.ArrowBackIosNew: Icon get() = Icon("arrow_back_ios_new")
actual val Icons.Filled.ArrowCircleDown: Icon get() = Icon("arrow_circle_down")
actual val Icons.Filled.ArrowCircleLeft: Icon get() = Icon("arrow_circle_left")
actual val Icons.Filled.ArrowCircleRight: Icon get() = Icon("arrow_circle_right")
actual val Icons.Filled.ArrowCircleUp: Icon get() = Icon("arrow_circle_up")
actual val Icons.Filled.ArrowDownward: Icon get() = Icon("arrow_downward")
actual val Icons.Filled.ArrowDropDownCircle: Icon get() = Icon("arrow_drop_down_circle")
actual val Icons.Filled.ArrowDropUp: Icon get() = Icon("arrow_drop_up")
actual val Icons.Filled.ArrowForwardIos: Icon get() = Icon("arrow_forward_ios")
actual val Icons.Filled.ArrowLeft: Icon get() = Icon("arrow_left")
actual val Icons.Filled.ArrowOutward: Icon get() = Icon("arrow_outward")
actual val Icons.Filled.ArrowRight: Icon get() = Icon("arrow_right")
actual val Icons.Filled.ArrowRightAlt: Icon get() = Icon("arrow_right_alt")
actual val Icons.Filled.ArrowUpward: Icon get() = Icon("arrow_upward")
actual val Icons.Filled.ArtTrack: Icon get() = Icon("art_track")
actual val Icons.Filled.Article: Icon get() = Icon("article")
actual val Icons.Filled.AspectRatio: Icon get() = Icon("aspect_ratio")
actual val Icons.Filled.Assignment: Icon get() = Icon("assignment")
actual val Icons.Filled.AssignmentInd: Icon get() = Icon("assignment_ind")
actual val Icons.Filled.AssignmentLate: Icon get() = Icon("assignment_late")
actual val Icons.Filled.AssignmentReturn: Icon get() = Icon("assignment_return")
actual val Icons.Filled.AssignmentReturned: Icon get() = Icon("assignment_returned")
actual val Icons.Filled.AssignmentTurnedIn: Icon get() = Icon("assignment_turned_in")
actual val Icons.Filled.AssistWalker: Icon get() = Icon("assist_walker")
actual val Icons.Filled.Assistant: Icon get() = Icon("assistant")
actual val Icons.Filled.AssistantDirection: Icon get() = Icon("assistant_direction")
actual val Icons.Filled.AssuredWorkload: Icon get() = Icon("assured_workload")
actual val Icons.Filled.Atm: Icon get() = Icon("atm")
actual val Icons.Filled.AttachEmail: Icon get() = Icon("attach_email")
actual val Icons.Filled.AttachFile: Icon get() = Icon("attach_file")
actual val Icons.Filled.AttachMoney: Icon get() = Icon("attach_money")
actual val Icons.Filled.Attachment: Icon get() = Icon("attachment")
actual val Icons.Filled.Attractions: Icon get() = Icon("attractions")
actual val Icons.Filled.Attribution: Icon get() = Icon("attribution")
actual val Icons.Filled.AudioFile: Icon get() = Icon("audio_file")
actual val Icons.Filled.AutoAwesome: Icon get() = Icon("auto_awesome")
actual val Icons.Filled.AutoAwesomeMosaic: Icon get() = Icon("auto_awesome_mosaic")
actual val Icons.Filled.AutoAwesomeMotion: Icon get() = Icon("auto_awesome_motion")
actual val Icons.Filled.AutoDelete: Icon get() = Icon("auto_delete")
actual val Icons.Filled.AutoFixNormal: Icon get() = Icon("auto_fix_normal")
actual val Icons.Filled.AutoFixOff: Icon get() = Icon("auto_fix_off")
actual val Icons.Filled.AutoGraph: Icon get() = Icon("auto_graph")
actual val Icons.Filled.AutoMode: Icon get() = Icon("auto_mode")
actual val Icons.Filled.AutoStories: Icon get() = Icon("auto_stories")
actual val Icons.Filled.AutofpsSelect: Icon get() = Icon("autofps_select")
actual val Icons.Filled.Autorenew: Icon get() = Icon("autorenew")
actual val Icons.Filled.AvTimer: Icon get() = Icon("av_timer")
actual val Icons.Filled.BabyChangingStation: Icon get() = Icon("baby_changing_station")
actual val Icons.Filled.BackHand: Icon get() = Icon("back_hand")
actual val Icons.Filled.Backpack: Icon get() = Icon("backpack")
actual val Icons.Filled.Backspace: Icon get() = Icon("backspace")
actual val Icons.Filled.Backup: Icon get() = Icon("backup")
actual val Icons.Filled.BackupTable: Icon get() = Icon("backup_table")
actual val Icons.Filled.Badge: Icon get() = Icon("badge")
actual val Icons.Filled.BakeryDining: Icon get() = Icon("bakery_dining")
actual val Icons.Filled.Balance: Icon get() = Icon("balance")
actual val Icons.Filled.Balcony: Icon get() = Icon("balcony")
actual val Icons.Filled.Ballot: Icon get() = Icon("ballot")
actual val Icons.Filled.BarChart: Icon get() = Icon("bar_chart")
actual val Icons.Filled.BatchPrediction: Icon get() = Icon("batch_prediction")
actual val Icons.Filled.Bathroom: Icon get() = Icon("bathroom")
actual val Icons.Filled.Bathtub: Icon get() = Icon("bathtub")
actual val Icons.Filled.Battery0Bar: Icon get() = Icon("battery_0_bar")
actual val Icons.Filled.Battery1Bar: Icon get() = Icon("battery_1_bar")
actual val Icons.Filled.Battery2Bar: Icon get() = Icon("battery_2_bar")
actual val Icons.Filled.Battery3Bar: Icon get() = Icon("battery_3_bar")
actual val Icons.Filled.Battery4Bar: Icon get() = Icon("battery_4_bar")
actual val Icons.Filled.Battery5Bar: Icon get() = Icon("battery_5_bar")
actual val Icons.Filled.Battery6Bar: Icon get() = Icon("battery_6_bar")
actual val Icons.Filled.BatteryAlert: Icon get() = Icon("battery_alert")
actual val Icons.Filled.BatteryChargingFull: Icon get() = Icon("battery_charging_full")
actual val Icons.Filled.BatteryFull: Icon get() = Icon("battery_full")
actual val Icons.Filled.BatterySaver: Icon get() = Icon("battery_saver")
actual val Icons.Filled.BatteryUnknown: Icon get() = Icon("battery_unknown")
actual val Icons.Filled.BeachAccess: Icon get() = Icon("beach_access")
actual val Icons.Filled.Bed: Icon get() = Icon("bed")
actual val Icons.Filled.BedroomBaby: Icon get() = Icon("bedroom_baby")
actual val Icons.Filled.BedroomChild: Icon get() = Icon("bedroom_child")
actual val Icons.Filled.BedroomParent: Icon get() = Icon("bedroom_parent")
actual val Icons.Filled.Bedtime: Icon get() = Icon("bedtime")
actual val Icons.Filled.BedtimeOff: Icon get() = Icon("bedtime_off")
actual val Icons.Filled.Beenhere: Icon get() = Icon("beenhere")
actual val Icons.Filled.Bento: Icon get() = Icon("bento")
actual val Icons.Filled.BikeScooter: Icon get() = Icon("bike_scooter")
actual val Icons.Filled.Biotech: Icon get() = Icon("biotech")
actual val Icons.Filled.Blender: Icon get() = Icon("blender")
actual val Icons.Filled.Blind: Icon get() = Icon("blind")
actual val Icons.Filled.Blinds: Icon get() = Icon("blinds")
actual val Icons.Filled.BlindsClosed: Icon get() = Icon("blinds_closed")
actual val Icons.Filled.Block: Icon get() = Icon("block")
actual val Icons.Filled.Bloodtype: Icon get() = Icon("bloodtype")
actual val Icons.Filled.Bluetooth: Icon get() = Icon("bluetooth")
actual val Icons.Filled.BluetoothConnected: Icon get() = Icon("bluetooth_connected")
actual val Icons.Filled.BluetoothDisabled: Icon get() = Icon("bluetooth_disabled")
actual val Icons.Filled.BluetoothDrive: Icon get() = Icon("bluetooth_drive")
actual val Icons.Filled.BluetoothSearching: Icon get() = Icon("bluetooth_searching")
actual val Icons.Filled.BlurCircular: Icon get() = Icon("blur_circular")
actual val Icons.Filled.BlurLinear: Icon get() = Icon("blur_linear")
actual val Icons.Filled.BlurOff: Icon get() = Icon("blur_off")
actual val Icons.Filled.BlurOn: Icon get() = Icon("blur_on")
actual val Icons.Filled.Bolt: Icon get() = Icon("bolt")
actual val Icons.Filled.Book: Icon get() = Icon("book")
actual val Icons.Filled.Bookmark: Icon get() = Icon("bookmark")
actual val Icons.Filled.BookmarkAdd: Icon get() = Icon("bookmark_add")
actual val Icons.Filled.BookmarkAdded: Icon get() = Icon("bookmark_added")
actual val Icons.Filled.BookmarkRemove: Icon get() = Icon("bookmark_remove")
actual val Icons.Filled.Bookmarks: Icon get() = Icon("bookmarks")
actual val Icons.Filled.BorderAll: Icon get() = Icon("border_all")
actual val Icons.Filled.BorderBottom: Icon get() = Icon("border_bottom")
actual val Icons.Filled.BorderClear: Icon get() = Icon("border_clear")
actual val Icons.Filled.BorderColor: Icon get() = Icon("border_color")
actual val Icons.Filled.BorderHorizontal: Icon get() = Icon("border_horizontal")
actual val Icons.Filled.BorderInner: Icon get() = Icon("border_inner")
actual val Icons.Filled.BorderLeft: Icon get() = Icon("border_left")
actual val Icons.Filled.BorderOuter: Icon get() = Icon("border_outer")
actual val Icons.Filled.BorderRight: Icon get() = Icon("border_right")
actual val Icons.Filled.BorderStyle: Icon get() = Icon("border_style")
actual val Icons.Filled.BorderTop: Icon get() = Icon("border_top")
actual val Icons.Filled.BorderVertical: Icon get() = Icon("border_vertical")
actual val Icons.Filled.Boy: Icon get() = Icon("boy")
actual val Icons.Filled.BrandingWatermark: Icon get() = Icon("branding_watermark")
actual val Icons.Filled.BreakfastDining: Icon get() = Icon("breakfast_dining")
actual val Icons.Filled.Brightness1: Icon get() = Icon("brightness_1")
actual val Icons.Filled.Brightness2: Icon get() = Icon("brightness_2")
actual val Icons.Filled.Brightness3: Icon get() = Icon("brightness_3")
actual val Icons.Filled.Brightness4: Icon get() = Icon("brightness_4")
actual val Icons.Filled.Brightness5: Icon get() = Icon("brightness_5")
actual val Icons.Filled.Brightness6: Icon get() = Icon("brightness_6")
actual val Icons.Filled.Brightness7: Icon get() = Icon("brightness_7")
actual val Icons.Filled.BrightnessAuto: Icon get() = Icon("brightness_auto")
actual val Icons.Filled.BrightnessHigh: Icon get() = Icon("brightness_high")
actual val Icons.Filled.BrightnessLow: Icon get() = Icon("brightness_low")
actual val Icons.Filled.BrightnessMedium: Icon get() = Icon("brightness_medium")
actual val Icons.Filled.BroadcastOnHome: Icon get() = Icon("broadcast_on_home")
actual val Icons.Filled.BroadcastOnPersonal: Icon get() = Icon("broadcast_on_personal")
actual val Icons.Filled.BrokenImage: Icon get() = Icon("broken_image")
actual val Icons.Filled.BrowseGallery: Icon get() = Icon("browse_gallery")
actual val Icons.Filled.BrowserUpdated: Icon get() = Icon("browser_updated")
actual val Icons.Filled.BrunchDining: Icon get() = Icon("brunch_dining")
actual val Icons.Filled.Brush: Icon get() = Icon("brush")
actual val Icons.Filled.BubbleChart: Icon get() = Icon("bubble_chart")
actual val Icons.Filled.BugReport: Icon get() = Icon("bug_report")
actual val Icons.Filled.BuildCircle: Icon get() = Icon("build_circle")
actual val Icons.Filled.Bungalow: Icon get() = Icon("bungalow")
actual val Icons.Filled.BurstMode: Icon get() = Icon("burst_mode")
actual val Icons.Filled.BusAlert: Icon get() = Icon("bus_alert")
actual val Icons.Filled.BusinessCenter: Icon get() = Icon("business_center")
actual val Icons.Filled.Cabin: Icon get() = Icon("cabin")
actual val Icons.Filled.Cable: Icon get() = Icon("cable")
actual val Icons.Filled.Cached: Icon get() = Icon("cached")
actual val Icons.Filled.Cake: Icon get() = Icon("cake")
actual val Icons.Filled.Calculate: Icon get() = Icon("calculate")
actual val Icons.Filled.CalendarMonth: Icon get() = Icon("calendar_month")
actual val Icons.Filled.CalendarToday: Icon get() = Icon("calendar_today")
actual val Icons.Filled.CalendarViewDay: Icon get() = Icon("calendar_view_day")
actual val Icons.Filled.CalendarViewMonth: Icon get() = Icon("calendar_view_month")
actual val Icons.Filled.CalendarViewWeek: Icon get() = Icon("calendar_view_week")
actual val Icons.Filled.CallEnd: Icon get() = Icon("call_end")
actual val Icons.Filled.CallMade: Icon get() = Icon("call_made")
actual val Icons.Filled.CallMerge: Icon get() = Icon("call_merge")
actual val Icons.Filled.CallMissed: Icon get() = Icon("call_missed")
actual val Icons.Filled.CallMissedOutgoing: Icon get() = Icon("call_missed_outgoing")
actual val Icons.Filled.CallReceived: Icon get() = Icon("call_received")
actual val Icons.Filled.CallSplit: Icon get() = Icon("call_split")
actual val Icons.Filled.CallToAction: Icon get() = Icon("call_to_action")
actual val Icons.Filled.Camera: Icon get() = Icon("camera")
actual val Icons.Filled.CameraEnhance: Icon get() = Icon("camera_enhance")
actual val Icons.Filled.CameraIndoor: Icon get() = Icon("camera_indoor")
actual val Icons.Filled.CameraOutdoor: Icon get() = Icon("camera_outdoor")
actual val Icons.Filled.CameraRoll: Icon get() = Icon("camera_roll")
actual val Icons.Filled.Cameraswitch: Icon get() = Icon("cameraswitch")
actual val Icons.Filled.Campaign: Icon get() = Icon("campaign")
actual val Icons.Filled.Cancel: Icon get() = Icon("cancel")
actual val Icons.Filled.CancelPresentation: Icon get() = Icon("cancel_presentation")
actual val Icons.Filled.CancelScheduleSend: Icon get() = Icon("cancel_schedule_send")
actual val Icons.Filled.CandlestickChart: Icon get() = Icon("candlestick_chart")
actual val Icons.Filled.CarCrash: Icon get() = Icon("car_crash")
actual val Icons.Filled.CarRental: Icon get() = Icon("car_rental")
actual val Icons.Filled.CarRepair: Icon get() = Icon("car_repair")
actual val Icons.Filled.CardMembership: Icon get() = Icon("card_membership")
actual val Icons.Filled.CardTravel: Icon get() = Icon("card_travel")
actual val Icons.Filled.Carpenter: Icon get() = Icon("carpenter")
actual val Icons.Filled.Cases: Icon get() = Icon("cases")
actual val Icons.Filled.Casino: Icon get() = Icon("casino")
actual val Icons.Filled.Cast: Icon get() = Icon("cast")
actual val Icons.Filled.CastConnected: Icon get() = Icon("cast_connected")
actual val Icons.Filled.CastForEducation: Icon get() = Icon("cast_for_education")
actual val Icons.Filled.Castle: Icon get() = Icon("castle")
actual val Icons.Filled.Category: Icon get() = Icon("category")
actual val Icons.Filled.Celebration: Icon get() = Icon("celebration")
actual val Icons.Filled.CellTower: Icon get() = Icon("cell_tower")
actual val Icons.Filled.CellWifi: Icon get() = Icon("cell_wifi")
actual val Icons.Filled.CenterFocusStrong: Icon get() = Icon("center_focus_strong")
actual val Icons.Filled.CenterFocusWeak: Icon get() = Icon("center_focus_weak")
actual val Icons.Filled.Chair: Icon get() = Icon("chair")
actual val Icons.Filled.ChairAlt: Icon get() = Icon("chair_alt")
actual val Icons.Filled.Chalet: Icon get() = Icon("chalet")
actual val Icons.Filled.ChangeCircle: Icon get() = Icon("change_circle")
actual val Icons.Filled.ChangeHistory: Icon get() = Icon("change_history")
actual val Icons.Filled.Chat: Icon get() = Icon("chat")
actual val Icons.Filled.ChatBubble: Icon get() = Icon("chat_bubble")
actual val Icons.Filled.CheckBox: Icon get() = Icon("check_box")
actual val Icons.Filled.CheckBoxOutlineBlank: Icon get() = Icon("check_box_outline_blank")
actual val Icons.Filled.Checklist: Icon get() = Icon("checklist")
actual val Icons.Filled.ChecklistRtl: Icon get() = Icon("checklist_rtl")
actual val Icons.Filled.Checkroom: Icon get() = Icon("checkroom")
actual val Icons.Filled.ChevronLeft: Icon get() = Icon("chevron_left")
actual val Icons.Filled.ChevronRight: Icon get() = Icon("chevron_right")
actual val Icons.Filled.ChildCare: Icon get() = Icon("child_care")
actual val Icons.Filled.ChildFriendly: Icon get() = Icon("child_friendly")
actual val Icons.Filled.ChromeReaderMode: Icon get() = Icon("chrome_reader_mode")
actual val Icons.Filled.Church: Icon get() = Icon("church")
actual val Icons.Filled.Circle: Icon get() = Icon("circle")
actual val Icons.Filled.CircleNotifications: Icon get() = Icon("circle_notifications")
actual val Icons.Filled.CleanHands: Icon get() = Icon("clean_hands")
actual val Icons.Filled.CleaningServices: Icon get() = Icon("cleaning_services")
actual val Icons.Filled.ClearAll: Icon get() = Icon("clear_all")
actual val Icons.Filled.CloseFullscreen: Icon get() = Icon("close_fullscreen")
actual val Icons.Filled.ClosedCaption: Icon get() = Icon("closed_caption")
actual val Icons.Filled.ClosedCaptionDisabled: Icon get() = Icon("closed_caption_disabled")
actual val Icons.Filled.Cloud: Icon get() = Icon("cloud")
actual val Icons.Filled.CloudCircle: Icon get() = Icon("cloud_circle")
actual val Icons.Filled.CloudDone: Icon get() = Icon("cloud_done")
actual val Icons.Filled.CloudDownload: Icon get() = Icon("cloud_download")
actual val Icons.Filled.CloudOff: Icon get() = Icon("cloud_off")
actual val Icons.Filled.CloudSync: Icon get() = Icon("cloud_sync")
actual val Icons.Filled.CloudUpload: Icon get() = Icon("cloud_upload")
actual val Icons.Filled.Co2: Icon get() = Icon("co2")
actual val Icons.Filled.CoPresent: Icon get() = Icon("co_present")
actual val Icons.Filled.Code: Icon get() = Icon("code")
actual val Icons.Filled.CodeOff: Icon get() = Icon("code_off")
actual val Icons.Filled.Coffee: Icon get() = Icon("coffee")
actual val Icons.Filled.CoffeeMaker: Icon get() = Icon("coffee_maker")
actual val Icons.Filled.CollectionsBookmark: Icon get() = Icon("collections_bookmark")
actual val Icons.Filled.Colorize: Icon get() = Icon("colorize")
actual val Icons.Filled.Comment: Icon get() = Icon("comment")
actual val Icons.Filled.CommentBank: Icon get() = Icon("comment_bank")
actual val Icons.Filled.CommentsDisabled: Icon get() = Icon("comments_disabled")
actual val Icons.Filled.Commit: Icon get() = Icon("commit")
actual val Icons.Filled.Commute: Icon get() = Icon("commute")
actual val Icons.Filled.Compare: Icon get() = Icon("compare")
actual val Icons.Filled.CompareArrows: Icon get() = Icon("compare_arrows")
actual val Icons.Filled.CompassCalibration: Icon get() = Icon("compass_calibration")
actual val Icons.Filled.Compost: Icon get() = Icon("compost")
actual val Icons.Filled.Compress: Icon get() = Icon("compress")
actual val Icons.Filled.Computer: Icon get() = Icon("computer")
actual val Icons.Filled.ConfirmationNumber: Icon get() = Icon("confirmation_number")
actual val Icons.Filled.ConnectWithoutContact: Icon get() = Icon("connect_without_contact")
actual val Icons.Filled.ConnectedTv: Icon get() = Icon("connected_tv")
actual val Icons.Filled.ConnectingAirports: Icon get() = Icon("connecting_airports")
actual val Icons.Filled.Construction: Icon get() = Icon("construction")
actual val Icons.Filled.ContactEmergency: Icon get() = Icon("contact_emergency")
actual val Icons.Filled.ContactMail: Icon get() = Icon("contact_mail")
actual val Icons.Filled.ContactPage: Icon get() = Icon("contact_page")
actual val Icons.Filled.ContactPhone: Icon get() = Icon("contact_phone")
actual val Icons.Filled.ContactSupport: Icon get() = Icon("contact_support")
actual val Icons.Filled.Contactless: Icon get() = Icon("contactless")
actual val Icons.Filled.Contacts: Icon get() = Icon("contacts")
actual val Icons.Filled.ContentCopy: Icon get() = Icon("content_copy")
actual val Icons.Filled.ContentCut: Icon get() = Icon("content_cut")
actual val Icons.Filled.ContentPaste: Icon get() = Icon("content_paste")
actual val Icons.Filled.ContentPasteGo: Icon get() = Icon("content_paste_go")
actual val Icons.Filled.ContentPasteOff: Icon get() = Icon("content_paste_off")
actual val Icons.Filled.ContentPasteSearch: Icon get() = Icon("content_paste_search")
actual val Icons.Filled.Contrast: Icon get() = Icon("contrast")
actual val Icons.Filled.ControlCamera: Icon get() = Icon("control_camera")
actual val Icons.Filled.ControlPointDuplicate: Icon get() = Icon("control_point_duplicate")
actual val Icons.Filled.Cookie: Icon get() = Icon("cookie")
actual val Icons.Filled.CopyAll: Icon get() = Icon("copy_all")
actual val Icons.Filled.Copyright: Icon get() = Icon("copyright")
actual val Icons.Filled.Coronavirus: Icon get() = Icon("coronavirus")
actual val Icons.Filled.CorporateFare: Icon get() = Icon("corporate_fare")
actual val Icons.Filled.Cottage: Icon get() = Icon("cottage")
actual val Icons.Filled.Countertops: Icon get() = Icon("countertops")
actual val Icons.Filled.CreateNewFolder: Icon get() = Icon("create_new_folder")
actual val Icons.Filled.CreditCard: Icon get() = Icon("credit_card")
actual val Icons.Filled.CreditCardOff: Icon get() = Icon("credit_card_off")
actual val Icons.Filled.CreditScore: Icon get() = Icon("credit_score")
actual val Icons.Filled.Crib: Icon get() = Icon("crib")
actual val Icons.Filled.CrisisAlert: Icon get() = Icon("crisis_alert")
actual val Icons.Filled.Crop: Icon get() = Icon("crop")
actual val Icons.Filled.Crop169: Icon get() = Icon("crop_16_9")
actual val Icons.Filled.Crop32: Icon get() = Icon("crop_3_2")
actual val Icons.Filled.Crop54: Icon get() = Icon("crop_5_4")
actual val Icons.Filled.Crop75: Icon get() = Icon("crop_7_5")
actual val Icons.Filled.CropFree: Icon get() = Icon("crop_free")
actual val Icons.Filled.CropLandscape: Icon get() = Icon("crop_landscape")
actual val Icons.Filled.CropPortrait: Icon get() = Icon("crop_portrait")
actual val Icons.Filled.CropRotate: Icon get() = Icon("crop_rotate")
actual val Icons.Filled.CropSquare: Icon get() = Icon("crop_square")
actual val Icons.Filled.CrueltyFree: Icon get() = Icon("cruelty_free")
actual val Icons.Filled.Css: Icon get() = Icon("css")
actual val Icons.Filled.CurrencyBitcoin: Icon get() = Icon("currency_bitcoin")
actual val Icons.Filled.CurrencyExchange: Icon get() = Icon("currency_exchange")
actual val Icons.Filled.CurrencyFranc: Icon get() = Icon("currency_franc")
actual val Icons.Filled.CurrencyLira: Icon get() = Icon("currency_lira")
actual val Icons.Filled.CurrencyPound: Icon get() = Icon("currency_pound")
actual val Icons.Filled.CurrencyRuble: Icon get() = Icon("currency_ruble")
actual val Icons.Filled.CurrencyRupee: Icon get() = Icon("currency_rupee")
actual val Icons.Filled.CurrencyYen: Icon get() = Icon("currency_yen")
actual val Icons.Filled.CurrencyYuan: Icon get() = Icon("currency_yuan")
actual val Icons.Filled.Curtains: Icon get() = Icon("curtains")
actual val Icons.Filled.CurtainsClosed: Icon get() = Icon("curtains_closed")
actual val Icons.Filled.Cyclone: Icon get() = Icon("cyclone")
actual val Icons.Filled.Dangerous: Icon get() = Icon("dangerous")
actual val Icons.Filled.DarkMode: Icon get() = Icon("dark_mode")
actual val Icons.Filled.Dashboard: Icon get() = Icon("dashboard")
actual val Icons.Filled.DashboardCustomize: Icon get() = Icon("dashboard_customize")
actual val Icons.Filled.DataArray: Icon get() = Icon("data_array")
actual val Icons.Filled.DataExploration: Icon get() = Icon("data_exploration")
actual val Icons.Filled.DataObject: Icon get() = Icon("data_object")
actual val Icons.Filled.DataSaverOn: Icon get() = Icon("data_saver_on")
actual val Icons.Filled.DataThresholding: Icon get() = Icon("data_thresholding")
actual val Icons.Filled.DataUsage: Icon get() = Icon("data_usage")
actual val Icons.Filled.Dataset: Icon get() = Icon("dataset")
actual val Icons.Filled.DatasetLinked: Icon get() = Icon("dataset_linked")
actual val Icons.Filled.Deblur: Icon get() = Icon("deblur")
actual val Icons.Filled.Deck: Icon get() = Icon("deck")
actual val Icons.Filled.Dehaze: Icon get() = Icon("dehaze")
actual val Icons.Filled.DeleteForever: Icon get() = Icon("delete_forever")
actual val Icons.Filled.DeleteSweep: Icon get() = Icon("delete_sweep")
actual val Icons.Filled.DensityLarge: Icon get() = Icon("density_large")
actual val Icons.Filled.DensityMedium: Icon get() = Icon("density_medium")
actual val Icons.Filled.DensitySmall: Icon get() = Icon("density_small")
actual val Icons.Filled.DepartureBoard: Icon get() = Icon("departure_board")
actual val Icons.Filled.Description: Icon get() = Icon("description")
actual val Icons.Filled.Deselect: Icon get() = Icon("deselect")
actual val Icons.Filled.DesignServices: Icon get() = Icon("design_services")
actual val Icons.Filled.Desk: Icon get() = Icon("desk")
actual val Icons.Filled.DesktopAccessDisabled: Icon get() = Icon("desktop_access_disabled")
actual val Icons.Filled.DesktopMac: Icon get() = Icon("desktop_mac")
actual val Icons.Filled.DesktopWindows: Icon get() = Icon("desktop_windows")
actual val Icons.Filled.Details: Icon get() = Icon("details")
actual val Icons.Filled.DeveloperBoard: Icon get() = Icon("developer_board")
actual val Icons.Filled.DeveloperBoardOff: Icon get() = Icon("developer_board_off")
actual val Icons.Filled.DeviceHub: Icon get() = Icon("device_hub")
actual val Icons.Filled.DeviceThermostat: Icon get() = Icon("device_thermostat")
actual val Icons.Filled.Devices: Icon get() = Icon("devices")
actual val Icons.Filled.DevicesFold: Icon get() = Icon("devices_fold")
actual val Icons.Filled.DevicesOther: Icon get() = Icon("devices_other")
actual val Icons.Filled.DialerSip: Icon get() = Icon("dialer_sip")
actual val Icons.Filled.Dialpad: Icon get() = Icon("dialpad")
actual val Icons.Filled.Diamond: Icon get() = Icon("diamond")
actual val Icons.Filled.Difference: Icon get() = Icon("difference")
actual val Icons.Filled.Dining: Icon get() = Icon("dining")
actual val Icons.Filled.DinnerDining: Icon get() = Icon("dinner_dining")
actual val Icons.Filled.Directions: Icon get() = Icon("directions")
actual val Icons.Filled.DirectionsBike: Icon get() = Icon("directions_bike")
actual val Icons.Filled.DirectionsBoat: Icon get() = Icon("directions_boat")
actual val Icons.Filled.DirectionsBus: Icon get() = Icon("directions_bus")
actual val Icons.Filled.DirectionsCar: Icon get() = Icon("directions_car")
actual val Icons.Filled.DirectionsOff: Icon get() = Icon("directions_off")
actual val Icons.Filled.DirectionsRailway: Icon get() = Icon("directions_railway")
actual val Icons.Filled.DirectionsRun: Icon get() = Icon("directions_run")
actual val Icons.Filled.DirectionsSubway: Icon get() = Icon("directions_subway")
actual val Icons.Filled.DirectionsWalk: Icon get() = Icon("directions_walk")
actual val Icons.Filled.DirtyLens: Icon get() = Icon("dirty_lens")
actual val Icons.Filled.DisabledByDefault: Icon get() = Icon("disabled_by_default")
actual val Icons.Filled.DisabledVisible: Icon get() = Icon("disabled_visible")
actual val Icons.Filled.DiscFull: Icon get() = Icon("disc_full")
actual val Icons.Filled.DisplaySettings: Icon get() = Icon("display_settings")
actual val Icons.Filled.Diversity1: Icon get() = Icon("diversity_1")
actual val Icons.Filled.Diversity2: Icon get() = Icon("diversity_2")
actual val Icons.Filled.Diversity3: Icon get() = Icon("diversity_3")
actual val Icons.Filled.Dns: Icon get() = Icon("dns")
actual val Icons.Filled.DoNotDisturb: Icon get() = Icon("do_not_disturb")
actual val Icons.Filled.DoNotDisturbOff: Icon get() = Icon("do_not_disturb_off")
actual val Icons.Filled.DoNotDisturbOn: Icon get() = Icon("do_not_disturb_on")
actual val Icons.Filled.DoNotDisturbOnTotalSilence: Icon get() = Icon("do_not_disturb_on_total_silence")
actual val Icons.Filled.DoNotStep: Icon get() = Icon("do_not_step")
actual val Icons.Filled.DoNotTouch: Icon get() = Icon("do_not_touch")
actual val Icons.Filled.Dock: Icon get() = Icon("dock")
actual val Icons.Filled.DocumentScanner: Icon get() = Icon("document_scanner")
actual val Icons.Filled.Domain: Icon get() = Icon("domain")
actual val Icons.Filled.DomainAdd: Icon get() = Icon("domain_add")
actual val Icons.Filled.DomainDisabled: Icon get() = Icon("domain_disabled")
actual val Icons.Filled.DomainVerification: Icon get() = Icon("domain_verification")
actual val Icons.Filled.DoneAll: Icon get() = Icon("done_all")
actual val Icons.Filled.DoneOutline: Icon get() = Icon("done_outline")
actual val Icons.Filled.DonutLarge: Icon get() = Icon("donut_large")
actual val Icons.Filled.DonutSmall: Icon get() = Icon("donut_small")
actual val Icons.Filled.DoorBack: Icon get() = Icon("door_back")
actual val Icons.Filled.DoorFront: Icon get() = Icon("door_front")
actual val Icons.Filled.DoorSliding: Icon get() = Icon("door_sliding")
actual val Icons.Filled.Doorbell: Icon get() = Icon("doorbell")
actual val Icons.Filled.DoubleArrow: Icon get() = Icon("double_arrow")
actual val Icons.Filled.DownhillSkiing: Icon get() = Icon("downhill_skiing")
actual val Icons.Filled.Download: Icon get() = Icon("download")
actual val Icons.Filled.DownloadDone: Icon get() = Icon("download_done")
actual val Icons.Filled.DownloadForOffline: Icon get() = Icon("download_for_offline")
actual val Icons.Filled.Downloading: Icon get() = Icon("downloading")
actual val Icons.Filled.Drafts: Icon get() = Icon("drafts")
actual val Icons.Filled.DragHandle: Icon get() = Icon("drag_handle")
actual val Icons.Filled.DragIndicator: Icon get() = Icon("drag_indicator")
actual val Icons.Filled.Draw: Icon get() = Icon("draw")
actual val Icons.Filled.DriveFileMove: Icon get() = Icon("drive_file_move")
actual val Icons.Filled.DriveFileRenameOutline: Icon get() = Icon("drive_file_rename_outline")
actual val Icons.Filled.DriveFolderUpload: Icon get() = Icon("drive_folder_upload")
actual val Icons.Filled.Dry: Icon get() = Icon("dry")
actual val Icons.Filled.DryCleaning: Icon get() = Icon("dry_cleaning")
actual val Icons.Filled.Duo: Icon get() = Icon("duo")
actual val Icons.Filled.Dvr: Icon get() = Icon("dvr")
actual val Icons.Filled.DynamicFeed: Icon get() = Icon("dynamic_feed")
actual val Icons.Filled.DynamicForm: Icon get() = Icon("dynamic_form")
actual val Icons.Filled.EMobiledata: Icon get() = Icon("e_mobiledata")
actual val Icons.Filled.Earbuds: Icon get() = Icon("earbuds")
actual val Icons.Filled.EarbudsBattery: Icon get() = Icon("earbuds_battery")
actual val Icons.Filled.East: Icon get() = Icon("east")
actual val Icons.Filled.Eco: Icon get() = Icon("eco")
actual val Icons.Filled.EditAttributes: Icon get() = Icon("edit_attributes")
actual val Icons.Filled.EditCalendar: Icon get() = Icon("edit_calendar")
actual val Icons.Filled.EditLocation: Icon get() = Icon("edit_location")
actual val Icons.Filled.EditLocationAlt: Icon get() = Icon("edit_location_alt")
actual val Icons.Filled.EditNote: Icon get() = Icon("edit_note")
actual val Icons.Filled.EditNotifications: Icon get() = Icon("edit_notifications")
actual val Icons.Filled.EditOff: Icon get() = Icon("edit_off")
actual val Icons.Filled.EditRoad: Icon get() = Icon("edit_road")
actual val Icons.Filled.Egg: Icon get() = Icon("egg")
actual val Icons.Filled.EggAlt: Icon get() = Icon("egg_alt")
actual val Icons.Filled.Eject: Icon get() = Icon("eject")
actual val Icons.Filled.Elderly: Icon get() = Icon("elderly")
actual val Icons.Filled.ElderlyWoman: Icon get() = Icon("elderly_woman")
actual val Icons.Filled.ElectricBike: Icon get() = Icon("electric_bike")
actual val Icons.Filled.ElectricBolt: Icon get() = Icon("electric_bolt")
actual val Icons.Filled.ElectricCar: Icon get() = Icon("electric_car")
actual val Icons.Filled.ElectricMeter: Icon get() = Icon("electric_meter")
actual val Icons.Filled.ElectricMoped: Icon get() = Icon("electric_moped")
actual val Icons.Filled.ElectricRickshaw: Icon get() = Icon("electric_rickshaw")
actual val Icons.Filled.ElectricScooter: Icon get() = Icon("electric_scooter")
actual val Icons.Filled.ElectricalServices: Icon get() = Icon("electrical_services")
actual val Icons.Filled.Elevator: Icon get() = Icon("elevator")
actual val Icons.Filled.Emergency: Icon get() = Icon("emergency")
actual val Icons.Filled.EmergencyRecording: Icon get() = Icon("emergency_recording")
actual val Icons.Filled.EmergencyShare: Icon get() = Icon("emergency_share")
actual val Icons.Filled.EmojiFoodBeverage: Icon get() = Icon("emoji_food_beverage")
actual val Icons.Filled.EmojiNature: Icon get() = Icon("emoji_nature")
actual val Icons.Filled.EmojiObjects: Icon get() = Icon("emoji_objects")
actual val Icons.Filled.EmojiPeople: Icon get() = Icon("emoji_people")
actual val Icons.Filled.EmojiSymbols: Icon get() = Icon("emoji_symbols")
actual val Icons.Filled.EmojiTransportation: Icon get() = Icon("emoji_transportation")
actual val Icons.Filled.EnergySavingsLeaf: Icon get() = Icon("energy_savings_leaf")
actual val Icons.Filled.Engineering: Icon get() = Icon("engineering")
actual val Icons.Filled.EnhancedEncryption: Icon get() = Icon("enhanced_encryption")
actual val Icons.Filled.Equalizer: Icon get() = Icon("equalizer")
actual val Icons.Filled.Error: Icon get() = Icon("error")
actual val Icons.Filled.Escalator: Icon get() = Icon("escalator")
actual val Icons.Filled.EscalatorWarning: Icon get() = Icon("escalator_warning")
actual val Icons.Filled.Euro: Icon get() = Icon("euro")
actual val Icons.Filled.EuroSymbol: Icon get() = Icon("euro_symbol")
actual val Icons.Filled.EvStation: Icon get() = Icon("ev_station")
actual val Icons.Filled.Event: Icon get() = Icon("event")
actual val Icons.Filled.EventAvailable: Icon get() = Icon("event_available")
actual val Icons.Filled.EventBusy: Icon get() = Icon("event_busy")
actual val Icons.Filled.EventNote: Icon get() = Icon("event_note")
actual val Icons.Filled.EventRepeat: Icon get() = Icon("event_repeat")
actual val Icons.Filled.EventSeat: Icon get() = Icon("event_seat")
actual val Icons.Filled.Expand: Icon get() = Icon("expand")
actual val Icons.Filled.ExpandCircleDown: Icon get() = Icon("expand_circle_down")
actual val Icons.Filled.ExpandLess: Icon get() = Icon("expand_less")
actual val Icons.Filled.ExpandMore: Icon get() = Icon("expand_more")
actual val Icons.Filled.Explicit: Icon get() = Icon("explicit")
actual val Icons.Filled.Explore: Icon get() = Icon("explore")
actual val Icons.Filled.ExploreOff: Icon get() = Icon("explore_off")
actual val Icons.Filled.Exposure: Icon get() = Icon("exposure")
actual val Icons.Filled.ExposureNeg1: Icon get() = Icon("exposure_neg_1")
actual val Icons.Filled.ExposureNeg2: Icon get() = Icon("exposure_neg_2")
actual val Icons.Filled.ExposurePlus1: Icon get() = Icon("exposure_plus_1")
actual val Icons.Filled.ExposurePlus2: Icon get() = Icon("exposure_plus_2")
actual val Icons.Filled.ExposureZero: Icon get() = Icon("exposure_zero")
actual val Icons.Filled.Extension: Icon get() = Icon("extension")
actual val Icons.Filled.ExtensionOff: Icon get() = Icon("extension_off")
actual val Icons.Filled.Face2: Icon get() = Icon("face_2")
actual val Icons.Filled.Face3: Icon get() = Icon("face_3")
actual val Icons.Filled.Face4: Icon get() = Icon("face_4")
actual val Icons.Filled.Face5: Icon get() = Icon("face_5")
actual val Icons.Filled.Face6: Icon get() = Icon("face_6")
actual val Icons.Filled.FaceRetouchingNatural: Icon get() = Icon("face_retouching_natural")
actual val Icons.Filled.FaceRetouchingOff: Icon get() = Icon("face_retouching_off")
actual val Icons.Filled.FactCheck: Icon get() = Icon("fact_check")
actual val Icons.Filled.Factory: Icon get() = Icon("factory")
actual val Icons.Filled.FamilyRestroom: Icon get() = Icon("family_restroom")
actual val Icons.Filled.FastForward: Icon get() = Icon("fast_forward")
actual val Icons.Filled.FastRewind: Icon get() = Icon("fast_rewind")
actual val Icons.Filled.Fastfood: Icon get() = Icon("fastfood")
actual val Icons.Filled.Fax: Icon get() = Icon("fax")
actual val Icons.Filled.FeaturedPlayList: Icon get() = Icon("featured_play_list")
actual val Icons.Filled.FeaturedVideo: Icon get() = Icon("featured_video")
actual val Icons.Filled.Feed: Icon get() = Icon("feed")
actual val Icons.Filled.Female: Icon get() = Icon("female")
actual val Icons.Filled.Fence: Icon get() = Icon("fence")
actual val Icons.Filled.Festival: Icon get() = Icon("festival")
actual val Icons.Filled.FiberDvr: Icon get() = Icon("fiber_dvr")
actual val Icons.Filled.FiberManualRecord: Icon get() = Icon("fiber_manual_record")
actual val Icons.Filled.FiberNew: Icon get() = Icon("fiber_new")
actual val Icons.Filled.FiberPin: Icon get() = Icon("fiber_pin")
actual val Icons.Filled.FiberSmartRecord: Icon get() = Icon("fiber_smart_record")
actual val Icons.Filled.FileCopy: Icon get() = Icon("file_copy")
actual val Icons.Filled.FileDownloadOff: Icon get() = Icon("file_download_off")
actual val Icons.Filled.FileOpen: Icon get() = Icon("file_open")
actual val Icons.Filled.FilePresent: Icon get() = Icon("file_present")
actual val Icons.Filled.Filter: Icon get() = Icon("filter")
actual val Icons.Filled.Filter1: Icon get() = Icon("filter_1")
actual val Icons.Filled.Filter2: Icon get() = Icon("filter_2")
actual val Icons.Filled.Filter3: Icon get() = Icon("filter_3")
actual val Icons.Filled.Filter4: Icon get() = Icon("filter_4")
actual val Icons.Filled.Filter5: Icon get() = Icon("filter_5")
actual val Icons.Filled.Filter6: Icon get() = Icon("filter_6")
actual val Icons.Filled.Filter7: Icon get() = Icon("filter_7")
actual val Icons.Filled.Filter8: Icon get() = Icon("filter_8")
actual val Icons.Filled.Filter9: Icon get() = Icon("filter_9")
actual val Icons.Filled.Filter9Plus: Icon get() = Icon("filter_9_plus")
actual val Icons.Filled.FilterAlt: Icon get() = Icon("filter_alt")
actual val Icons.Filled.FilterAltOff: Icon get() = Icon("filter_alt_off")
actual val Icons.Filled.FilterBAndW: Icon get() = Icon("filter_b_and_w")
actual val Icons.Filled.FilterCenterFocus: Icon get() = Icon("filter_center_focus")
actual val Icons.Filled.FilterDrama: Icon get() = Icon("filter_drama")
actual val Icons.Filled.FilterFrames: Icon get() = Icon("filter_frames")
actual val Icons.Filled.FilterHdr: Icon get() = Icon("filter_hdr")
actual val Icons.Filled.FilterList: Icon get() = Icon("filter_list")
actual val Icons.Filled.FilterListOff: Icon get() = Icon("filter_list_off")
actual val Icons.Filled.FilterNone: Icon get() = Icon("filter_none")
actual val Icons.Filled.FilterTiltShift: Icon get() = Icon("filter_tilt_shift")
actual val Icons.Filled.FilterVintage: Icon get() = Icon("filter_vintage")
actual val Icons.Filled.FindInPage: Icon get() = Icon("find_in_page")
actual val Icons.Filled.FindReplace: Icon get() = Icon("find_replace")
actual val Icons.Filled.Fingerprint: Icon get() = Icon("fingerprint")
actual val Icons.Filled.FireExtinguisher: Icon get() = Icon("fire_extinguisher")
actual val Icons.Filled.FireTruck: Icon get() = Icon("fire_truck")
actual val Icons.Filled.Fireplace: Icon get() = Icon("fireplace")
actual val Icons.Filled.FirstPage: Icon get() = Icon("first_page")
actual val Icons.Filled.FitScreen: Icon get() = Icon("fit_screen")
actual val Icons.Filled.FitnessCenter: Icon get() = Icon("fitness_center")
actual val Icons.Filled.Flag: Icon get() = Icon("flag")
actual val Icons.Filled.FlagCircle: Icon get() = Icon("flag_circle")
actual val Icons.Filled.Flaky: Icon get() = Icon("flaky")
actual val Icons.Filled.Flare: Icon get() = Icon("flare")
actual val Icons.Filled.FlashAuto: Icon get() = Icon("flash_auto")
actual val Icons.Filled.FlashOff: Icon get() = Icon("flash_off")
actual val Icons.Filled.FlashOn: Icon get() = Icon("flash_on")
actual val Icons.Filled.FlashlightOff: Icon get() = Icon("flashlight_off")
actual val Icons.Filled.FlashlightOn: Icon get() = Icon("flashlight_on")
actual val Icons.Filled.Flatware: Icon get() = Icon("flatware")
actual val Icons.Filled.Flight: Icon get() = Icon("flight")
actual val Icons.Filled.FlightClass: Icon get() = Icon("flight_class")
actual val Icons.Filled.FlightLand: Icon get() = Icon("flight_land")
actual val Icons.Filled.FlightTakeoff: Icon get() = Icon("flight_takeoff")
actual val Icons.Filled.Flip: Icon get() = Icon("flip")
actual val Icons.Filled.FlipCameraAndroid: Icon get() = Icon("flip_camera_android")
actual val Icons.Filled.FlipCameraIos: Icon get() = Icon("flip_camera_ios")
actual val Icons.Filled.FlipToBack: Icon get() = Icon("flip_to_back")
actual val Icons.Filled.FlipToFront: Icon get() = Icon("flip_to_front")
actual val Icons.Filled.Flood: Icon get() = Icon("flood")
actual val Icons.Filled.FlutterDash: Icon get() = Icon("flutter_dash")
actual val Icons.Filled.FmdBad: Icon get() = Icon("fmd_bad")
actual val Icons.Filled.Folder: Icon get() = Icon("folder")
actual val Icons.Filled.FolderCopy: Icon get() = Icon("folder_copy")
actual val Icons.Filled.FolderDelete: Icon get() = Icon("folder_delete")
actual val Icons.Filled.FolderOff: Icon get() = Icon("folder_off")
actual val Icons.Filled.FolderOpen: Icon get() = Icon("folder_open")
actual val Icons.Filled.FolderShared: Icon get() = Icon("folder_shared")
actual val Icons.Filled.FolderSpecial: Icon get() = Icon("folder_special")
actual val Icons.Filled.FolderZip: Icon get() = Icon("folder_zip")
actual val Icons.Filled.FollowTheSigns: Icon get() = Icon("follow_the_signs")
actual val Icons.Filled.FontDownload: Icon get() = Icon("font_download")
actual val Icons.Filled.FontDownloadOff: Icon get() = Icon("font_download_off")
actual val Icons.Filled.FoodBank: Icon get() = Icon("food_bank")
actual val Icons.Filled.Forest: Icon get() = Icon("forest")
actual val Icons.Filled.ForkLeft: Icon get() = Icon("fork_left")
actual val Icons.Filled.ForkRight: Icon get() = Icon("fork_right")
actual val Icons.Filled.FormatAlignCenter: Icon get() = Icon("format_align_center")
actual val Icons.Filled.FormatAlignJustify: Icon get() = Icon("format_align_justify")
actual val Icons.Filled.FormatAlignLeft: Icon get() = Icon("format_align_left")
actual val Icons.Filled.FormatAlignRight: Icon get() = Icon("format_align_right")
actual val Icons.Filled.FormatBold: Icon get() = Icon("format_bold")
actual val Icons.Filled.FormatClear: Icon get() = Icon("format_clear")
actual val Icons.Filled.FormatColorFill: Icon get() = Icon("format_color_fill")
actual val Icons.Filled.FormatColorReset: Icon get() = Icon("format_color_reset")
actual val Icons.Filled.FormatColorText: Icon get() = Icon("format_color_text")
actual val Icons.Filled.FormatIndentDecrease: Icon get() = Icon("format_indent_decrease")
actual val Icons.Filled.FormatIndentIncrease: Icon get() = Icon("format_indent_increase")
actual val Icons.Filled.FormatItalic: Icon get() = Icon("format_italic")
actual val Icons.Filled.FormatLineSpacing: Icon get() = Icon("format_line_spacing")
actual val Icons.Filled.FormatListBulleted: Icon get() = Icon("format_list_bulleted")
actual val Icons.Filled.FormatListNumbered: Icon get() = Icon("format_list_numbered")
actual val Icons.Filled.FormatListNumberedRtl: Icon get() = Icon("format_list_numbered_rtl")
actual val Icons.Filled.FormatOverline: Icon get() = Icon("format_overline")
actual val Icons.Filled.FormatPaint: Icon get() = Icon("format_paint")
actual val Icons.Filled.FormatQuote: Icon get() = Icon("format_quote")
actual val Icons.Filled.FormatShapes: Icon get() = Icon("format_shapes")
actual val Icons.Filled.FormatSize: Icon get() = Icon("format_size")
actual val Icons.Filled.FormatStrikethrough: Icon get() = Icon("format_strikethrough")
actual val Icons.Filled.FormatTextdirectionLToR: Icon get() = Icon("format_textdirection_l_to_r")
actual val Icons.Filled.FormatTextdirectionRToL: Icon get() = Icon("format_textdirection_r_to_l")
actual val Icons.Filled.FormatUnderlined: Icon get() = Icon("format_underlined")
actual val Icons.Filled.Fort: Icon get() = Icon("fort")
actual val Icons.Filled.Forum: Icon get() = Icon("forum")
actual val Icons.Filled.Forward: Icon get() = Icon("forward")
actual val Icons.Filled.Forward10: Icon get() = Icon("forward_10")
actual val Icons.Filled.Forward30: Icon get() = Icon("forward_30")
actual val Icons.Filled.Forward5: Icon get() = Icon("forward_5")
actual val Icons.Filled.ForwardToInbox: Icon get() = Icon("forward_to_inbox")
actual val Icons.Filled.Foundation: Icon get() = Icon("foundation")
actual val Icons.Filled.FreeCancellation: Icon get() = Icon("free_cancellation")
actual val Icons.Filled.FrontHand: Icon get() = Icon("front_hand")
actual val Icons.Filled.Fullscreen: Icon get() = Icon("fullscreen")
actual val Icons.Filled.FullscreenExit: Icon get() = Icon("fullscreen_exit")
actual val Icons.Filled.Functions: Icon get() = Icon("functions")
actual val Icons.Filled.GMobiledata: Icon get() = Icon("g_mobiledata")
actual val Icons.Filled.GTranslate: Icon get() = Icon("g_translate")
actual val Icons.Filled.Gamepad: Icon get() = Icon("gamepad")
actual val Icons.Filled.Garage: Icon get() = Icon("garage")
actual val Icons.Filled.GasMeter: Icon get() = Icon("gas_meter")
actual val Icons.Filled.Gavel: Icon get() = Icon("gavel")
actual val Icons.Filled.GeneratingTokens: Icon get() = Icon("generating_tokens")
actual val Icons.Filled.Gesture: Icon get() = Icon("gesture")
actual val Icons.Filled.Gif: Icon get() = Icon("gif")
actual val Icons.Filled.GifBox: Icon get() = Icon("gif_box")
actual val Icons.Filled.Girl: Icon get() = Icon("girl")
actual val Icons.Filled.Gite: Icon get() = Icon("gite")
actual val Icons.Filled.GolfCourse: Icon get() = Icon("golf_course")
actual val Icons.Filled.GppBad: Icon get() = Icon("gpp_bad")
actual val Icons.Filled.GppMaybe: Icon get() = Icon("gpp_maybe")
actual val Icons.Filled.Gradient: Icon get() = Icon("gradient")
actual val Icons.Filled.Grading: Icon get() = Icon("grading")
actual val Icons.Filled.Grain: Icon get() = Icon("grain")
actual val Icons.Filled.GraphicEq: Icon get() = Icon("graphic_eq")
actual val Icons.Filled.Grass: Icon get() = Icon("grass")
actual val Icons.Filled.Grid3x3: Icon get() = Icon("grid_3x3")
actual val Icons.Filled.Grid4x4: Icon get() = Icon("grid_4x4")
actual val Icons.Filled.GridGoldenratio: Icon get() = Icon("grid_goldenratio")
actual val Icons.Filled.GridOff: Icon get() = Icon("grid_off")
actual val Icons.Filled.GridOn: Icon get() = Icon("grid_on")
actual val Icons.Filled.GridView: Icon get() = Icon("grid_view")
actual val Icons.Filled.Group: Icon get() = Icon("group")
actual val Icons.Filled.GroupAdd: Icon get() = Icon("group_add")
actual val Icons.Filled.GroupOff: Icon get() = Icon("group_off")
actual val Icons.Filled.GroupRemove: Icon get() = Icon("group_remove")
actual val Icons.Filled.GroupWork: Icon get() = Icon("group_work")
actual val Icons.Filled.Groups: Icon get() = Icon("groups")
actual val Icons.Filled.Groups2: Icon get() = Icon("groups_2")
actual val Icons.Filled.Groups3: Icon get() = Icon("groups_3")
actual val Icons.Filled.HMobiledata: Icon get() = Icon("h_mobiledata")
actual val Icons.Filled.HPlusMobiledata: Icon get() = Icon("h_plus_mobiledata")
actual val Icons.Filled.Hail: Icon get() = Icon("hail")
actual val Icons.Filled.Handshake: Icon get() = Icon("handshake")
actual val Icons.Filled.Handyman: Icon get() = Icon("handyman")
actual val Icons.Filled.Hardware: Icon get() = Icon("hardware")
actual val Icons.Filled.Hd: Icon get() = Icon("hd")
actual val Icons.Filled.HdrAuto: Icon get() = Icon("hdr_auto")
actual val Icons.Filled.HdrAutoSelect: Icon get() = Icon("hdr_auto_select")
actual val Icons.Filled.HdrEnhancedSelect: Icon get() = Icon("hdr_enhanced_select")
actual val Icons.Filled.HdrOff: Icon get() = Icon("hdr_off")
actual val Icons.Filled.HdrOffSelect: Icon get() = Icon("hdr_off_select")
actual val Icons.Filled.HdrOn: Icon get() = Icon("hdr_on")
actual val Icons.Filled.HdrOnSelect: Icon get() = Icon("hdr_on_select")
actual val Icons.Filled.HdrPlus: Icon get() = Icon("hdr_plus")
actual val Icons.Filled.HdrStrong: Icon get() = Icon("hdr_strong")
actual val Icons.Filled.HdrWeak: Icon get() = Icon("hdr_weak")
actual val Icons.Filled.Headphones: Icon get() = Icon("headphones")
actual val Icons.Filled.HeadphonesBattery: Icon get() = Icon("headphones_battery")
actual val Icons.Filled.HeadsetMic: Icon get() = Icon("headset_mic")
actual val Icons.Filled.HeadsetOff: Icon get() = Icon("headset_off")
actual val Icons.Filled.Healing: Icon get() = Icon("healing")
actual val Icons.Filled.HealthAndSafety: Icon get() = Icon("health_and_safety")
actual val Icons.Filled.Hearing: Icon get() = Icon("hearing")
actual val Icons.Filled.HearingDisabled: Icon get() = Icon("hearing_disabled")
actual val Icons.Filled.HeartBroken: Icon get() = Icon("heart_broken")
actual val Icons.Filled.HeatPump: Icon get() = Icon("heat_pump")
actual val Icons.Filled.Height: Icon get() = Icon("height")
actual val Icons.Filled.Help: Icon get() = Icon("help")
actual val Icons.Filled.HelpCenter: Icon get() = Icon("help_center")
actual val Icons.Filled.Hevc: Icon get() = Icon("hevc")
actual val Icons.Filled.Hexagon: Icon get() = Icon("hexagon")
actual val Icons.Filled.HideImage: Icon get() = Icon("hide_image")
actual val Icons.Filled.HideSource: Icon get() = Icon("hide_source")
actual val Icons.Filled.HighQuality: Icon get() = Icon("high_quality")
actual val Icons.Filled.Highlight: Icon get() = Icon("highlight")
actual val Icons.Filled.Hiking: Icon get() = Icon("hiking")
actual val Icons.Filled.History: Icon get() = Icon("history")
actual val Icons.Filled.HistoryEdu: Icon get() = Icon("history_edu")
actual val Icons.Filled.HistoryToggleOff: Icon get() = Icon("history_toggle_off")
actual val Icons.Filled.Hive: Icon get() = Icon("hive")
actual val Icons.Filled.Hls: Icon get() = Icon("hls")
actual val Icons.Filled.HlsOff: Icon get() = Icon("hls_off")
actual val Icons.Filled.HolidayVillage: Icon get() = Icon("holiday_village")
actual val Icons.Filled.HomeMax: Icon get() = Icon("home_max")
actual val Icons.Filled.HomeMini: Icon get() = Icon("home_mini")
actual val Icons.Filled.HomeRepairService: Icon get() = Icon("home_repair_service")
actual val Icons.Filled.HomeWork: Icon get() = Icon("home_work")
actual val Icons.Filled.HorizontalDistribute: Icon get() = Icon("horizontal_distribute")
actual val Icons.Filled.HorizontalRule: Icon get() = Icon("horizontal_rule")
actual val Icons.Filled.HorizontalSplit: Icon get() = Icon("horizontal_split")
actual val Icons.Filled.HotTub: Icon get() = Icon("hot_tub")
actual val Icons.Filled.Hotel: Icon get() = Icon("hotel")
actual val Icons.Filled.HotelClass: Icon get() = Icon("hotel_class")
actual val Icons.Filled.HourglassBottom: Icon get() = Icon("hourglass_bottom")
actual val Icons.Filled.HourglassDisabled: Icon get() = Icon("hourglass_disabled")
actual val Icons.Filled.HourglassEmpty: Icon get() = Icon("hourglass_empty")
actual val Icons.Filled.HourglassFull: Icon get() = Icon("hourglass_full")
actual val Icons.Filled.HourglassTop: Icon get() = Icon("hourglass_top")
actual val Icons.Filled.House: Icon get() = Icon("house")
actual val Icons.Filled.HouseSiding: Icon get() = Icon("house_siding")
actual val Icons.Filled.Houseboat: Icon get() = Icon("houseboat")
actual val Icons.Filled.HowToReg: Icon get() = Icon("how_to_reg")
actual val Icons.Filled.HowToVote: Icon get() = Icon("how_to_vote")
actual val Icons.Filled.Html: Icon get() = Icon("html")
actual val Icons.Filled.Http: Icon get() = Icon("http")
actual val Icons.Filled.Hub: Icon get() = Icon("hub")
actual val Icons.Filled.Hvac: Icon get() = Icon("hvac")
actual val Icons.Filled.IceSkating: Icon get() = Icon("ice_skating")
actual val Icons.Filled.Icecream: Icon get() = Icon("icecream")
actual val Icons.Filled.Image: Icon get() = Icon("image")
actual val Icons.Filled.ImageAspectRatio: Icon get() = Icon("image_aspect_ratio")
actual val Icons.Filled.ImageNotSupported: Icon get() = Icon("image_not_supported")
actual val Icons.Filled.ImageSearch: Icon get() = Icon("image_search")
actual val Icons.Filled.ImagesearchRoller: Icon get() = Icon("imagesearch_roller")
actual val Icons.Filled.ImportContacts: Icon get() = Icon("import_contacts")
actual val Icons.Filled.ImportantDevices: Icon get() = Icon("important_devices")
actual val Icons.Filled.Inbox: Icon get() = Icon("inbox")
actual val Icons.Filled.IncompleteCircle: Icon get() = Icon("incomplete_circle")
actual val Icons.Filled.IndeterminateCheckBox: Icon get() = Icon("indeterminate_check_box")
actual val Icons.Filled.Input: Icon get() = Icon("input")
actual val Icons.Filled.InsertChart: Icon get() = Icon("insert_chart")
actual val Icons.Filled.InsertPageBreak: Icon get() = Icon("insert_page_break")
actual val Icons.Filled.Insights: Icon get() = Icon("insights")
actual val Icons.Filled.InstallDesktop: Icon get() = Icon("install_desktop")
actual val Icons.Filled.IntegrationInstructions: Icon get() = Icon("integration_instructions")
actual val Icons.Filled.Interests: Icon get() = Icon("interests")
actual val Icons.Filled.InterpreterMode: Icon get() = Icon("interpreter_mode")
actual val Icons.Filled.Inventory: Icon get() = Icon("inventory")
actual val Icons.Filled.Inventory2: Icon get() = Icon("inventory_2")
actual val Icons.Filled.InvertColors: Icon get() = Icon("invert_colors")
actual val Icons.Filled.InvertColorsOff: Icon get() = Icon("invert_colors_off")
actual val Icons.Filled.IosShare: Icon get() = Icon("ios_share")
actual val Icons.Filled.Iron: Icon get() = Icon("iron")
actual val Icons.Filled.Javascript: Icon get() = Icon("javascript")
actual val Icons.Filled.JoinInner: Icon get() = Icon("join_inner")
actual val Icons.Filled.JoinLeft: Icon get() = Icon("join_left")
actual val Icons.Filled.JoinRight: Icon get() = Icon("join_right")
actual val Icons.Filled.Kayaking: Icon get() = Icon("kayaking")
actual val Icons.Filled.KebabDining: Icon get() = Icon("kebab_dining")
actual val Icons.Filled.Key: Icon get() = Icon("key")
actual val Icons.Filled.KeyOff: Icon get() = Icon("key_off")
actual val Icons.Filled.Keyboard: Icon get() = Icon("keyboard")
actual val Icons.Filled.KeyboardAlt: Icon get() = Icon("keyboard_alt")
actual val Icons.Filled.KeyboardBackspace: Icon get() = Icon("keyboard_backspace")
actual val Icons.Filled.KeyboardCapslock: Icon get() = Icon("keyboard_capslock")
actual val Icons.Filled.KeyboardCommandKey: Icon get() = Icon("keyboard_command_key")
actual val Icons.Filled.KeyboardControlKey: Icon get() = Icon("keyboard_control_key")
actual val Icons.Filled.KeyboardDoubleArrowDown: Icon get() = Icon("keyboard_double_arrow_down")
actual val Icons.Filled.KeyboardDoubleArrowLeft: Icon get() = Icon("keyboard_double_arrow_left")
actual val Icons.Filled.KeyboardDoubleArrowRight: Icon get() = Icon("keyboard_double_arrow_right")
actual val Icons.Filled.KeyboardDoubleArrowUp: Icon get() = Icon("keyboard_double_arrow_up")
actual val Icons.Filled.KeyboardHide: Icon get() = Icon("keyboard_hide")
actual val Icons.Filled.KeyboardOptionKey: Icon get() = Icon("keyboard_option_key")
actual val Icons.Filled.KeyboardReturn: Icon get() = Icon("keyboard_return")
actual val Icons.Filled.KeyboardTab: Icon get() = Icon("keyboard_tab")
actual val Icons.Filled.KingBed: Icon get() = Icon("king_bed")
actual val Icons.Filled.Kitchen: Icon get() = Icon("kitchen")
actual val Icons.Filled.Kitesurfing: Icon get() = Icon("kitesurfing")
actual val Icons.Filled.Label: Icon get() = Icon("label")
actual val Icons.Filled.LabelImportant: Icon get() = Icon("label_important")
actual val Icons.Filled.LabelOff: Icon get() = Icon("label_off")
actual val Icons.Filled.Lan: Icon get() = Icon("lan")
actual val Icons.Filled.Landscape: Icon get() = Icon("landscape")
actual val Icons.Filled.Landslide: Icon get() = Icon("landslide")
actual val Icons.Filled.Language: Icon get() = Icon("language")
actual val Icons.Filled.LaptopChromebook: Icon get() = Icon("laptop_chromebook")
actual val Icons.Filled.LaptopMac: Icon get() = Icon("laptop_mac")
actual val Icons.Filled.LaptopWindows: Icon get() = Icon("laptop_windows")
actual val Icons.Filled.LastPage: Icon get() = Icon("last_page")
actual val Icons.Filled.Layers: Icon get() = Icon("layers")
actual val Icons.Filled.LayersClear: Icon get() = Icon("layers_clear")
actual val Icons.Filled.Leaderboard: Icon get() = Icon("leaderboard")
actual val Icons.Filled.LeakAdd: Icon get() = Icon("leak_add")
actual val Icons.Filled.LeakRemove: Icon get() = Icon("leak_remove")
actual val Icons.Filled.LegendToggle: Icon get() = Icon("legend_toggle")
actual val Icons.Filled.LensBlur: Icon get() = Icon("lens_blur")
actual val Icons.Filled.LibraryAdd: Icon get() = Icon("library_add")
actual val Icons.Filled.LibraryAddCheck: Icon get() = Icon("library_add_check")
actual val Icons.Filled.LibraryBooks: Icon get() = Icon("library_books")
actual val Icons.Filled.LibraryMusic: Icon get() = Icon("library_music")
actual val Icons.Filled.Light: Icon get() = Icon("light")
actual val Icons.Filled.LightMode: Icon get() = Icon("light_mode")
actual val Icons.Filled.Lightbulb: Icon get() = Icon("lightbulb")
actual val Icons.Filled.LightbulbCircle: Icon get() = Icon("lightbulb_circle")
actual val Icons.Filled.LineAxis: Icon get() = Icon("line_axis")
actual val Icons.Filled.LineStyle: Icon get() = Icon("line_style")
actual val Icons.Filled.LineWeight: Icon get() = Icon("line_weight")
actual val Icons.Filled.LinearScale: Icon get() = Icon("linear_scale")
actual val Icons.Filled.Link: Icon get() = Icon("link")
actual val Icons.Filled.LinkOff: Icon get() = Icon("link_off")
actual val Icons.Filled.LinkedCamera: Icon get() = Icon("linked_camera")
actual val Icons.Filled.Liquor: Icon get() = Icon("liquor")
actual val Icons.Filled.ListAlt: Icon get() = Icon("list_alt")
actual val Icons.Filled.LiveHelp: Icon get() = Icon("live_help")
actual val Icons.Filled.LiveTv: Icon get() = Icon("live_tv")
actual val Icons.Filled.Living: Icon get() = Icon("living")
actual val Icons.Filled.LocalActivity: Icon get() = Icon("local_activity")
actual val Icons.Filled.LocalAtm: Icon get() = Icon("local_atm")
actual val Icons.Filled.LocalBar: Icon get() = Icon("local_bar")
actual val Icons.Filled.LocalCafe: Icon get() = Icon("local_cafe")
actual val Icons.Filled.LocalCarWash: Icon get() = Icon("local_car_wash")
actual val Icons.Filled.LocalConvenienceStore: Icon get() = Icon("local_convenience_store")
actual val Icons.Filled.LocalDrink: Icon get() = Icon("local_drink")
actual val Icons.Filled.LocalFireDepartment: Icon get() = Icon("local_fire_department")
actual val Icons.Filled.LocalFlorist: Icon get() = Icon("local_florist")
actual val Icons.Filled.LocalGasStation: Icon get() = Icon("local_gas_station")
actual val Icons.Filled.LocalHospital: Icon get() = Icon("local_hospital")
actual val Icons.Filled.LocalLaundryService: Icon get() = Icon("local_laundry_service")
actual val Icons.Filled.LocalLibrary: Icon get() = Icon("local_library")
actual val Icons.Filled.LocalMall: Icon get() = Icon("local_mall")
actual val Icons.Filled.LocalParking: Icon get() = Icon("local_parking")
actual val Icons.Filled.LocalPharmacy: Icon get() = Icon("local_pharmacy")
actual val Icons.Filled.LocalPizza: Icon get() = Icon("local_pizza")
actual val Icons.Filled.LocalPolice: Icon get() = Icon("local_police")
actual val Icons.Filled.LocalPostOffice: Icon get() = Icon("local_post_office")
actual val Icons.Filled.LocalSee: Icon get() = Icon("local_see")
actual val Icons.Filled.LocalShipping: Icon get() = Icon("local_shipping")
actual val Icons.Filled.LocalTaxi: Icon get() = Icon("local_taxi")
actual val Icons.Filled.LocationCity: Icon get() = Icon("location_city")
actual val Icons.Filled.LocationDisabled: Icon get() = Icon("location_disabled")
actual val Icons.Filled.LocationOff: Icon get() = Icon("location_off")
actual val Icons.Filled.LocationSearching: Icon get() = Icon("location_searching")
actual val Icons.Filled.LockClock: Icon get() = Icon("lock_clock")
actual val Icons.Filled.LockOpen: Icon get() = Icon("lock_open")
actual val Icons.Filled.LockPerson: Icon get() = Icon("lock_person")
actual val Icons.Filled.LockReset: Icon get() = Icon("lock_reset")
actual val Icons.Filled.Login: Icon get() = Icon("login")
actual val Icons.Filled.LogoDev: Icon get() = Icon("logo_dev")
actual val Icons.Filled.Logout: Icon get() = Icon("logout")
actual val Icons.Filled.Looks: Icon get() = Icon("looks")
actual val Icons.Filled.Looks3: Icon get() = Icon("looks_3")
actual val Icons.Filled.Looks4: Icon get() = Icon("looks_4")
actual val Icons.Filled.Looks5: Icon get() = Icon("looks_5")
actual val Icons.Filled.Looks6: Icon get() = Icon("looks_6")
actual val Icons.Filled.LooksOne: Icon get() = Icon("looks_one")
actual val Icons.Filled.LooksTwo: Icon get() = Icon("looks_two")
actual val Icons.Filled.Loupe: Icon get() = Icon("loupe")
actual val Icons.Filled.LowPriority: Icon get() = Icon("low_priority")
actual val Icons.Filled.Loyalty: Icon get() = Icon("loyalty")
actual val Icons.Filled.LteMobiledata: Icon get() = Icon("lte_mobiledata")
actual val Icons.Filled.LtePlusMobiledata: Icon get() = Icon("lte_plus_mobiledata")
actual val Icons.Filled.Luggage: Icon get() = Icon("luggage")
actual val Icons.Filled.LunchDining: Icon get() = Icon("lunch_dining")
actual val Icons.Filled.Lyrics: Icon get() = Icon("lyrics")
actual val Icons.Filled.MacroOff: Icon get() = Icon("macro_off")
actual val Icons.Filled.Mail: Icon get() = Icon("mail")
actual val Icons.Filled.MailLock: Icon get() = Icon("mail_lock")
actual val Icons.Filled.Male: Icon get() = Icon("male")
actual val Icons.Filled.Man: Icon get() = Icon("man")
actual val Icons.Filled.Man2: Icon get() = Icon("man_2")
actual val Icons.Filled.Man3: Icon get() = Icon("man_3")
actual val Icons.Filled.Man4: Icon get() = Icon("man_4")
actual val Icons.Filled.ManageAccounts: Icon get() = Icon("manage_accounts")
actual val Icons.Filled.ManageHistory: Icon get() = Icon("manage_history")
actual val Icons.Filled.ManageSearch: Icon get() = Icon("manage_search")
actual val Icons.Filled.Map: Icon get() = Icon("map")
actual val Icons.Filled.MapsUgc: Icon get() = Icon("maps_ugc")
actual val Icons.Filled.Margin: Icon get() = Icon("margin")
actual val Icons.Filled.MarkAsUnread: Icon get() = Icon("mark_as_unread")
actual val Icons.Filled.MarkChatRead: Icon get() = Icon("mark_chat_read")
actual val Icons.Filled.MarkChatUnread: Icon get() = Icon("mark_chat_unread")
actual val Icons.Filled.MarkEmailRead: Icon get() = Icon("mark_email_read")
actual val Icons.Filled.MarkEmailUnread: Icon get() = Icon("mark_email_unread")
actual val Icons.Filled.MarkUnreadChatAlt: Icon get() = Icon("mark_unread_chat_alt")
actual val Icons.Filled.MarkunreadMailbox: Icon get() = Icon("markunread_mailbox")
actual val Icons.Filled.Masks: Icon get() = Icon("masks")
actual val Icons.Filled.Maximize: Icon get() = Icon("maximize")
actual val Icons.Filled.MediaBluetoothOff: Icon get() = Icon("media_bluetooth_off")
actual val Icons.Filled.MediaBluetoothOn: Icon get() = Icon("media_bluetooth_on")
actual val Icons.Filled.Mediation: Icon get() = Icon("mediation")
actual val Icons.Filled.MedicalInformation: Icon get() = Icon("medical_information")
actual val Icons.Filled.MedicalServices: Icon get() = Icon("medical_services")
actual val Icons.Filled.Medication: Icon get() = Icon("medication")
actual val Icons.Filled.MeetingRoom: Icon get() = Icon("meeting_room")
actual val Icons.Filled.Memory: Icon get() = Icon("memory")
actual val Icons.Filled.MenuBook: Icon get() = Icon("menu_book")
actual val Icons.Filled.MenuOpen: Icon get() = Icon("menu_open")
actual val Icons.Filled.Merge: Icon get() = Icon("merge")
actual val Icons.Filled.MergeType: Icon get() = Icon("merge_type")
actual val Icons.Filled.Mic: Icon get() = Icon("mic")
actual val Icons.Filled.MicExternalOff: Icon get() = Icon("mic_external_off")
actual val Icons.Filled.MicExternalOn: Icon get() = Icon("mic_external_on")
actual val Icons.Filled.MicOff: Icon get() = Icon("mic_off")
actual val Icons.Filled.Microwave: Icon get() = Icon("microwave")
actual val Icons.Filled.MilitaryTech: Icon get() = Icon("military_tech")
actual val Icons.Filled.Minimize: Icon get() = Icon("minimize")
actual val Icons.Filled.MinorCrash: Icon get() = Icon("minor_crash")
actual val Icons.Filled.MissedVideoCall: Icon get() = Icon("missed_video_call")
actual val Icons.Filled.Mms: Icon get() = Icon("mms")
actual val Icons.Filled.MobileOff: Icon get() = Icon("mobile_off")
actual val Icons.Filled.MobiledataOff: Icon get() = Icon("mobiledata_off")
actual val Icons.Filled.ModeComment: Icon get() = Icon("mode_comment")
actual val Icons.Filled.ModeFanOff: Icon get() = Icon("mode_fan_off")
actual val Icons.Filled.ModeOfTravel: Icon get() = Icon("mode_of_travel")
actual val Icons.Filled.ModeStandby: Icon get() = Icon("mode_standby")
actual val Icons.Filled.ModelTraining: Icon get() = Icon("model_training")
actual val Icons.Filled.MonetizationOn: Icon get() = Icon("monetization_on")
actual val Icons.Filled.Money: Icon get() = Icon("money")
actual val Icons.Filled.MoneyOff: Icon get() = Icon("money_off")
actual val Icons.Filled.Monitor: Icon get() = Icon("monitor")
actual val Icons.Filled.MonitorHeart: Icon get() = Icon("monitor_heart")
actual val Icons.Filled.MonitorWeight: Icon get() = Icon("monitor_weight")
actual val Icons.Filled.MonochromePhotos: Icon get() = Icon("monochrome_photos")
actual val Icons.Filled.Mood: Icon get() = Icon("mood")
actual val Icons.Filled.MoodBad: Icon get() = Icon("mood_bad")
actual val Icons.Filled.Moped: Icon get() = Icon("moped")
actual val Icons.Filled.More: Icon get() = Icon("more")
actual val Icons.Filled.MoreHoriz: Icon get() = Icon("more_horiz")
actual val Icons.Filled.MoreTime: Icon get() = Icon("more_time")
actual val Icons.Filled.Mosque: Icon get() = Icon("mosque")
actual val Icons.Filled.MotionPhotosAuto: Icon get() = Icon("motion_photos_auto")
actual val Icons.Filled.MotionPhotosOff: Icon get() = Icon("motion_photos_off")
actual val Icons.Filled.MotionPhotosOn: Icon get() = Icon("motion_photos_on")
actual val Icons.Filled.MotionPhotosPaused: Icon get() = Icon("motion_photos_paused")
actual val Icons.Filled.Motorcycle: Icon get() = Icon("motorcycle")
actual val Icons.Filled.Mouse: Icon get() = Icon("mouse")
actual val Icons.Filled.MoveDown: Icon get() = Icon("move_down")
actual val Icons.Filled.MoveToInbox: Icon get() = Icon("move_to_inbox")
actual val Icons.Filled.MoveUp: Icon get() = Icon("move_up")
actual val Icons.Filled.Movie: Icon get() = Icon("movie")
actual val Icons.Filled.MovieFilter: Icon get() = Icon("movie_filter")
actual val Icons.Filled.Moving: Icon get() = Icon("moving")
actual val Icons.Filled.Mp: Icon get() = Icon("mp")
actual val Icons.Filled.MultilineChart: Icon get() = Icon("multiline_chart")
actual val Icons.Filled.MultipleStop: Icon get() = Icon("multiple_stop")
actual val Icons.Filled.Museum: Icon get() = Icon("museum")
actual val Icons.Filled.MusicNote: Icon get() = Icon("music_note")
actual val Icons.Filled.MusicOff: Icon get() = Icon("music_off")
actual val Icons.Filled.MusicVideo: Icon get() = Icon("music_video")
actual val Icons.Filled.MyLocation: Icon get() = Icon("my_location")
actual val Icons.Filled.Nat: Icon get() = Icon("nat")
actual val Icons.Filled.Nature: Icon get() = Icon("nature")
actual val Icons.Filled.NaturePeople: Icon get() = Icon("nature_people")
actual val Icons.Filled.Navigation: Icon get() = Icon("navigation")
actual val Icons.Filled.NearMe: Icon get() = Icon("near_me")
actual val Icons.Filled.NearMeDisabled: Icon get() = Icon("near_me_disabled")
actual val Icons.Filled.NearbyError: Icon get() = Icon("nearby_error")
actual val Icons.Filled.NearbyOff: Icon get() = Icon("nearby_off")
actual val Icons.Filled.NestCamWiredStand: Icon get() = Icon("nest_cam_wired_stand")
actual val Icons.Filled.NetworkCell: Icon get() = Icon("network_cell")
actual val Icons.Filled.NetworkCheck: Icon get() = Icon("network_check")
actual val Icons.Filled.NetworkLocked: Icon get() = Icon("network_locked")
actual val Icons.Filled.NetworkPing: Icon get() = Icon("network_ping")
actual val Icons.Filled.NetworkWifi: Icon get() = Icon("network_wifi")
actual val Icons.Filled.NetworkWifi1Bar: Icon get() = Icon("network_wifi_1_bar")
actual val Icons.Filled.NetworkWifi2Bar: Icon get() = Icon("network_wifi_2_bar")
actual val Icons.Filled.NetworkWifi3Bar: Icon get() = Icon("network_wifi_3_bar")
actual val Icons.Filled.NewLabel: Icon get() = Icon("new_label")
actual val Icons.Filled.Newspaper: Icon get() = Icon("newspaper")
actual val Icons.Filled.NextPlan: Icon get() = Icon("next_plan")
actual val Icons.Filled.NextWeek: Icon get() = Icon("next_week")
actual val Icons.Filled.Nfc: Icon get() = Icon("nfc")
actual val Icons.Filled.NightShelter: Icon get() = Icon("night_shelter")
actual val Icons.Filled.Nightlife: Icon get() = Icon("nightlife")
actual val Icons.Filled.Nightlight: Icon get() = Icon("nightlight")
actual val Icons.Filled.NoAccounts: Icon get() = Icon("no_accounts")
actual val Icons.Filled.NoAdultContent: Icon get() = Icon("no_adult_content")
actual val Icons.Filled.NoBackpack: Icon get() = Icon("no_backpack")
actual val Icons.Filled.NoCrash: Icon get() = Icon("no_crash")
actual val Icons.Filled.NoDrinks: Icon get() = Icon("no_drinks")
actual val Icons.Filled.NoEncryption: Icon get() = Icon("no_encryption")
actual val Icons.Filled.NoFlash: Icon get() = Icon("no_flash")
actual val Icons.Filled.NoFood: Icon get() = Icon("no_food")
actual val Icons.Filled.NoLuggage: Icon get() = Icon("no_luggage")
actual val Icons.Filled.NoMeals: Icon get() = Icon("no_meals")
actual val Icons.Filled.NoMeetingRoom: Icon get() = Icon("no_meeting_room")
actual val Icons.Filled.NoPhotography: Icon get() = Icon("no_photography")
actual val Icons.Filled.NoSim: Icon get() = Icon("no_sim")
actual val Icons.Filled.NoStroller: Icon get() = Icon("no_stroller")
actual val Icons.Filled.NoTransfer: Icon get() = Icon("no_transfer")
actual val Icons.Filled.NoiseAware: Icon get() = Icon("noise_aware")
actual val Icons.Filled.NoiseControlOff: Icon get() = Icon("noise_control_off")
actual val Icons.Filled.NordicWalking: Icon get() = Icon("nordic_walking")
actual val Icons.Filled.North: Icon get() = Icon("north")
actual val Icons.Filled.NorthEast: Icon get() = Icon("north_east")
actual val Icons.Filled.NorthWest: Icon get() = Icon("north_west")
actual val Icons.Filled.NotAccessible: Icon get() = Icon("not_accessible")
actual val Icons.Filled.NotListedLocation: Icon get() = Icon("not_listed_location")
actual val Icons.Filled.NotStarted: Icon get() = Icon("not_started")
actual val Icons.Filled.Note: Icon get() = Icon("note")
actual val Icons.Filled.NoteAdd: Icon get() = Icon("note_add")
actual val Icons.Filled.NoteAlt: Icon get() = Icon("note_alt")
actual val Icons.Filled.Notes: Icon get() = Icon("notes")
actual val Icons.Filled.NotificationAdd: Icon get() = Icon("notification_add")
actual val Icons.Filled.NotificationImportant: Icon get() = Icon("notification_important")
actual val Icons.Filled.NotificationsActive: Icon get() = Icon("notifications_active")
actual val Icons.Filled.NotificationsOff: Icon get() = Icon("notifications_off")
actual val Icons.Filled.NotificationsPaused: Icon get() = Icon("notifications_paused")
actual val Icons.Filled.Numbers: Icon get() = Icon("numbers")
actual val Icons.Filled.OfflineBolt: Icon get() = Icon("offline_bolt")
actual val Icons.Filled.OfflinePin: Icon get() = Icon("offline_pin")
actual val Icons.Filled.OilBarrel: Icon get() = Icon("oil_barrel")
actual val Icons.Filled.OnDeviceTraining: Icon get() = Icon("on_device_training")
actual val Icons.Filled.OnlinePrediction: Icon get() = Icon("online_prediction")
actual val Icons.Filled.Opacity: Icon get() = Icon("opacity")
actual val Icons.Filled.OpenInBrowser: Icon get() = Icon("open_in_browser")
actual val Icons.Filled.OpenInFull: Icon get() = Icon("open_in_full")
actual val Icons.Filled.OpenInNew: Icon get() = Icon("open_in_new")
actual val Icons.Filled.OpenInNewOff: Icon get() = Icon("open_in_new_off")
actual val Icons.Filled.OpenWith: Icon get() = Icon("open_with")
actual val Icons.Filled.OtherHouses: Icon get() = Icon("other_houses")
actual val Icons.Filled.Outbound: Icon get() = Icon("outbound")
actual val Icons.Filled.Outbox: Icon get() = Icon("outbox")
actual val Icons.Filled.OutdoorGrill: Icon get() = Icon("outdoor_grill")
actual val Icons.Filled.Outlet: Icon get() = Icon("outlet")
actual val Icons.Filled.Output: Icon get() = Icon("output")
actual val Icons.Filled.Padding: Icon get() = Icon("padding")
actual val Icons.Filled.Pages: Icon get() = Icon("pages")
actual val Icons.Filled.Pageview: Icon get() = Icon("pageview")
actual val Icons.Filled.Paid: Icon get() = Icon("paid")
actual val Icons.Filled.Palette: Icon get() = Icon("palette")
actual val Icons.Filled.PanTool: Icon get() = Icon("pan_tool")
actual val Icons.Filled.PanToolAlt: Icon get() = Icon("pan_tool_alt")
actual val Icons.Filled.Panorama: Icon get() = Icon("panorama")
actual val Icons.Filled.PanoramaFishEye: Icon get() = Icon("panorama_fish_eye")
actual val Icons.Filled.PanoramaHorizontal: Icon get() = Icon("panorama_horizontal")
actual val Icons.Filled.PanoramaPhotosphere: Icon get() = Icon("panorama_photosphere")
actual val Icons.Filled.PanoramaVertical: Icon get() = Icon("panorama_vertical")
actual val Icons.Filled.PanoramaWideAngle: Icon get() = Icon("panorama_wide_angle")
actual val Icons.Filled.Paragliding: Icon get() = Icon("paragliding")
actual val Icons.Filled.Park: Icon get() = Icon("park")
actual val Icons.Filled.PartyMode: Icon get() = Icon("party_mode")
actual val Icons.Filled.Password: Icon get() = Icon("password")
actual val Icons.Filled.Pattern: Icon get() = Icon("pattern")
actual val Icons.Filled.Pause: Icon get() = Icon("pause")
actual val Icons.Filled.PauseCircle: Icon get() = Icon("pause_circle")
actual val Icons.Filled.PausePresentation: Icon get() = Icon("pause_presentation")
actual val Icons.Filled.Payments: Icon get() = Icon("payments")
actual val Icons.Filled.PedalBike: Icon get() = Icon("pedal_bike")
actual val Icons.Filled.Pending: Icon get() = Icon("pending")
actual val Icons.Filled.PendingActions: Icon get() = Icon("pending_actions")
actual val Icons.Filled.Pentagon: Icon get() = Icon("pentagon")
actual val Icons.Filled.Percent: Icon get() = Icon("percent")
actual val Icons.Filled.PermCameraMic: Icon get() = Icon("perm_camera_mic")
actual val Icons.Filled.PermContactCalendar: Icon get() = Icon("perm_contact_calendar")
actual val Icons.Filled.PermDataSetting: Icon get() = Icon("perm_data_setting")
actual val Icons.Filled.PermMedia: Icon get() = Icon("perm_media")
actual val Icons.Filled.PermPhoneMsg: Icon get() = Icon("perm_phone_msg")
actual val Icons.Filled.PermScanWifi: Icon get() = Icon("perm_scan_wifi")
actual val Icons.Filled.Person2: Icon get() = Icon("person_2")
actual val Icons.Filled.Person3: Icon get() = Icon("person_3")
actual val Icons.Filled.Person4: Icon get() = Icon("person_4")
actual val Icons.Filled.PersonAdd: Icon get() = Icon("person_add")
actual val Icons.Filled.PersonAddDisabled: Icon get() = Icon("person_add_disabled")
actual val Icons.Filled.PersonOff: Icon get() = Icon("person_off")
actual val Icons.Filled.PersonPin: Icon get() = Icon("person_pin")
actual val Icons.Filled.PersonPinCircle: Icon get() = Icon("person_pin_circle")
actual val Icons.Filled.PersonRemove: Icon get() = Icon("person_remove")
actual val Icons.Filled.PersonSearch: Icon get() = Icon("person_search")
actual val Icons.Filled.PersonalInjury: Icon get() = Icon("personal_injury")
actual val Icons.Filled.PestControl: Icon get() = Icon("pest_control")
actual val Icons.Filled.PestControlRodent: Icon get() = Icon("pest_control_rodent")
actual val Icons.Filled.Pets: Icon get() = Icon("pets")
actual val Icons.Filled.Phishing: Icon get() = Icon("phishing")
actual val Icons.Filled.PhoneBluetoothSpeaker: Icon get() = Icon("phone_bluetooth_speaker")
actual val Icons.Filled.PhoneCallback: Icon get() = Icon("phone_callback")
actual val Icons.Filled.PhoneDisabled: Icon get() = Icon("phone_disabled")
actual val Icons.Filled.PhoneEnabled: Icon get() = Icon("phone_enabled")
actual val Icons.Filled.PhoneForwarded: Icon get() = Icon("phone_forwarded")
actual val Icons.Filled.PhoneInTalk: Icon get() = Icon("phone_in_talk")
actual val Icons.Filled.PhoneLocked: Icon get() = Icon("phone_locked")
actual val Icons.Filled.PhoneMissed: Icon get() = Icon("phone_missed")
actual val Icons.Filled.PhonePaused: Icon get() = Icon("phone_paused")
actual val Icons.Filled.Photo: Icon get() = Icon("photo")
actual val Icons.Filled.PhotoAlbum: Icon get() = Icon("photo_album")
actual val Icons.Filled.PhotoCamera: Icon get() = Icon("photo_camera")
actual val Icons.Filled.PhotoCameraBack: Icon get() = Icon("photo_camera_back")
actual val Icons.Filled.PhotoCameraFront: Icon get() = Icon("photo_camera_front")
actual val Icons.Filled.PhotoFilter: Icon get() = Icon("photo_filter")
actual val Icons.Filled.PhotoLibrary: Icon get() = Icon("photo_library")
actual val Icons.Filled.PhotoSizeSelectLarge: Icon get() = Icon("photo_size_select_large")
actual val Icons.Filled.PhotoSizeSelectSmall: Icon get() = Icon("photo_size_select_small")
actual val Icons.Filled.Php: Icon get() = Icon("php")
actual val Icons.Filled.Piano: Icon get() = Icon("piano")
actual val Icons.Filled.PianoOff: Icon get() = Icon("piano_off")
actual val Icons.Filled.PictureAsPdf: Icon get() = Icon("picture_as_pdf")
actual val Icons.Filled.PictureInPicture: Icon get() = Icon("picture_in_picture")
actual val Icons.Filled.PictureInPictureAlt: Icon get() = Icon("picture_in_picture_alt")
actual val Icons.Filled.PieChart: Icon get() = Icon("pie_chart")
actual val Icons.Filled.Pin: Icon get() = Icon("pin")
actual val Icons.Filled.PinDrop: Icon get() = Icon("pin_drop")
actual val Icons.Filled.PinEnd: Icon get() = Icon("pin_end")
actual val Icons.Filled.PinInvoke: Icon get() = Icon("pin_invoke")
actual val Icons.Filled.Pinch: Icon get() = Icon("pinch")
actual val Icons.Filled.PivotTableChart: Icon get() = Icon("pivot_table_chart")
actual val Icons.Filled.Plagiarism: Icon get() = Icon("plagiarism")
actual val Icons.Filled.PlayCircle: Icon get() = Icon("play_circle")
actual val Icons.Filled.PlayDisabled: Icon get() = Icon("play_disabled")
actual val Icons.Filled.PlayForWork: Icon get() = Icon("play_for_work")
actual val Icons.Filled.PlayLesson: Icon get() = Icon("play_lesson")
actual val Icons.Filled.PlaylistAdd: Icon get() = Icon("playlist_add")
actual val Icons.Filled.PlaylistAddCheck: Icon get() = Icon("playlist_add_check")
actual val Icons.Filled.PlaylistAddCheckCircle: Icon get() = Icon("playlist_add_check_circle")
actual val Icons.Filled.PlaylistAddCircle: Icon get() = Icon("playlist_add_circle")
actual val Icons.Filled.PlaylistPlay: Icon get() = Icon("playlist_play")
actual val Icons.Filled.PlaylistRemove: Icon get() = Icon("playlist_remove")
actual val Icons.Filled.Plumbing: Icon get() = Icon("plumbing")
actual val Icons.Filled.Podcasts: Icon get() = Icon("podcasts")
actual val Icons.Filled.PointOfSale: Icon get() = Icon("point_of_sale")
actual val Icons.Filled.Policy: Icon get() = Icon("policy")
actual val Icons.Filled.Polyline: Icon get() = Icon("polyline")
actual val Icons.Filled.Polymer: Icon get() = Icon("polymer")
actual val Icons.Filled.Pool: Icon get() = Icon("pool")
actual val Icons.Filled.PostAdd: Icon get() = Icon("post_add")
actual val Icons.Filled.Power: Icon get() = Icon("power")
actual val Icons.Filled.PowerInput: Icon get() = Icon("power_input")
actual val Icons.Filled.PowerOff: Icon get() = Icon("power_off")
actual val Icons.Filled.PowerSettingsNew: Icon get() = Icon("power_settings_new")
actual val Icons.Filled.PrecisionManufacturing: Icon get() = Icon("precision_manufacturing")
actual val Icons.Filled.PresentToAll: Icon get() = Icon("present_to_all")
actual val Icons.Filled.Preview: Icon get() = Icon("preview")
actual val Icons.Filled.PriceChange: Icon get() = Icon("price_change")
actual val Icons.Filled.PriceCheck: Icon get() = Icon("price_check")
actual val Icons.Filled.Print: Icon get() = Icon("print")
actual val Icons.Filled.PrintDisabled: Icon get() = Icon("print_disabled")
actual val Icons.Filled.PriorityHigh: Icon get() = Icon("priority_high")
actual val Icons.Filled.PrivacyTip: Icon get() = Icon("privacy_tip")
actual val Icons.Filled.PrivateConnectivity: Icon get() = Icon("private_connectivity")
actual val Icons.Filled.ProductionQuantityLimits: Icon get() = Icon("production_quantity_limits")
actual val Icons.Filled.Propane: Icon get() = Icon("propane")
actual val Icons.Filled.PropaneTank: Icon get() = Icon("propane_tank")
actual val Icons.Filled.Psychology: Icon get() = Icon("psychology")
actual val Icons.Filled.PsychologyAlt: Icon get() = Icon("psychology_alt")
actual val Icons.Filled.Public: Icon get() = Icon("public")
actual val Icons.Filled.PublicOff: Icon get() = Icon("public_off")
actual val Icons.Filled.Publish: Icon get() = Icon("publish")
actual val Icons.Filled.PublishedWithChanges: Icon get() = Icon("published_with_changes")
actual val Icons.Filled.PunchClock: Icon get() = Icon("punch_clock")
actual val Icons.Filled.PushPin: Icon get() = Icon("push_pin")
actual val Icons.Filled.QrCode: Icon get() = Icon("qr_code")
actual val Icons.Filled.QrCode2: Icon get() = Icon("qr_code_2")
actual val Icons.Filled.QrCodeScanner: Icon get() = Icon("qr_code_scanner")
actual val Icons.Filled.QueryStats: Icon get() = Icon("query_stats")
actual val Icons.Filled.QuestionMark: Icon get() = Icon("question_mark")
actual val Icons.Filled.QueueMusic: Icon get() = Icon("queue_music")
actual val Icons.Filled.QueuePlayNext: Icon get() = Icon("queue_play_next")
actual val Icons.Filled.Quickreply: Icon get() = Icon("quickreply")
actual val Icons.Filled.Quiz: Icon get() = Icon("quiz")
actual val Icons.Filled.RMobiledata: Icon get() = Icon("r_mobiledata")
actual val Icons.Filled.Radar: Icon get() = Icon("radar")
actual val Icons.Filled.Radio: Icon get() = Icon("radio")
actual val Icons.Filled.RadioButtonChecked: Icon get() = Icon("radio_button_checked")
actual val Icons.Filled.RadioButtonUnchecked: Icon get() = Icon("radio_button_unchecked")
actual val Icons.Filled.RailwayAlert: Icon get() = Icon("railway_alert")
actual val Icons.Filled.RamenDining: Icon get() = Icon("ramen_dining")
actual val Icons.Filled.RampLeft: Icon get() = Icon("ramp_left")
actual val Icons.Filled.RampRight: Icon get() = Icon("ramp_right")
actual val Icons.Filled.RateReview: Icon get() = Icon("rate_review")
actual val Icons.Filled.RawOff: Icon get() = Icon("raw_off")
actual val Icons.Filled.RawOn: Icon get() = Icon("raw_on")
actual val Icons.Filled.ReadMore: Icon get() = Icon("read_more")
actual val Icons.Filled.RealEstateAgent: Icon get() = Icon("real_estate_agent")
actual val Icons.Filled.Receipt: Icon get() = Icon("receipt")
actual val Icons.Filled.ReceiptLong: Icon get() = Icon("receipt_long")
actual val Icons.Filled.RecentActors: Icon get() = Icon("recent_actors")
actual val Icons.Filled.Recommend: Icon get() = Icon("recommend")
actual val Icons.Filled.RecordVoiceOver: Icon get() = Icon("record_voice_over")
actual val Icons.Filled.Rectangle: Icon get() = Icon("rectangle")
actual val Icons.Filled.Recycling: Icon get() = Icon("recycling")
actual val Icons.Filled.Redeem: Icon get() = Icon("redeem")
actual val Icons.Filled.Redo: Icon get() = Icon("redo")
actual val Icons.Filled.ReduceCapacity: Icon get() = Icon("reduce_capacity")
actual val Icons.Filled.RememberMe: Icon get() = Icon("remember_me")
actual val Icons.Filled.Remove: Icon get() = Icon("remove")
actual val Icons.Filled.RemoveDone: Icon get() = Icon("remove_done")
actual val Icons.Filled.RemoveFromQueue: Icon get() = Icon("remove_from_queue")
actual val Icons.Filled.RemoveModerator: Icon get() = Icon("remove_moderator")
actual val Icons.Filled.RemoveRoad: Icon get() = Icon("remove_road")
actual val Icons.Filled.RemoveShoppingCart: Icon get() = Icon("remove_shopping_cart")
actual val Icons.Filled.Reorder: Icon get() = Icon("reorder")
actual val Icons.Filled.Repartition: Icon get() = Icon("repartition")
actual val Icons.Filled.Repeat: Icon get() = Icon("repeat")
actual val Icons.Filled.RepeatOn: Icon get() = Icon("repeat_on")
actual val Icons.Filled.RepeatOne: Icon get() = Icon("repeat_one")
actual val Icons.Filled.RepeatOneOn: Icon get() = Icon("repeat_one_on")
actual val Icons.Filled.Replay: Icon get() = Icon("replay")
actual val Icons.Filled.Replay10: Icon get() = Icon("replay_10")
actual val Icons.Filled.Replay30: Icon get() = Icon("replay_30")
actual val Icons.Filled.Replay5: Icon get() = Icon("replay_5")
actual val Icons.Filled.ReplayCircleFilled: Icon get() = Icon("replay_circle_filled")
actual val Icons.Filled.Reply: Icon get() = Icon("reply")
actual val Icons.Filled.ReplyAll: Icon get() = Icon("reply_all")
actual val Icons.Filled.Report: Icon get() = Icon("report")
actual val Icons.Filled.ReportOff: Icon get() = Icon("report_off")
actual val Icons.Filled.RequestPage: Icon get() = Icon("request_page")
actual val Icons.Filled.RequestQuote: Icon get() = Icon("request_quote")
actual val Icons.Filled.ResetTv: Icon get() = Icon("reset_tv")
actual val Icons.Filled.RestartAlt: Icon get() = Icon("restart_alt")
actual val Icons.Filled.Restaurant: Icon get() = Icon("restaurant")
actual val Icons.Filled.RestaurantMenu: Icon get() = Icon("restaurant_menu")
actual val Icons.Filled.RestoreFromTrash: Icon get() = Icon("restore_from_trash")
actual val Icons.Filled.RestorePage: Icon get() = Icon("restore_page")
actual val Icons.Filled.Reviews: Icon get() = Icon("reviews")
actual val Icons.Filled.RiceBowl: Icon get() = Icon("rice_bowl")
actual val Icons.Filled.RingVolume: Icon get() = Icon("ring_volume")
actual val Icons.Filled.Rocket: Icon get() = Icon("rocket")
actual val Icons.Filled.RocketLaunch: Icon get() = Icon("rocket_launch")
actual val Icons.Filled.RollerShades: Icon get() = Icon("roller_shades")
actual val Icons.Filled.RollerShadesClosed: Icon get() = Icon("roller_shades_closed")
actual val Icons.Filled.RollerSkating: Icon get() = Icon("roller_skating")
actual val Icons.Filled.Roofing: Icon get() = Icon("roofing")
actual val Icons.Filled.RoomPreferences: Icon get() = Icon("room_preferences")
actual val Icons.Filled.RoomService: Icon get() = Icon("room_service")
actual val Icons.Filled.Rotate90DegreesCcw: Icon get() = Icon("rotate_90_degrees_ccw")
actual val Icons.Filled.Rotate90DegreesCw: Icon get() = Icon("rotate_90_degrees_cw")
actual val Icons.Filled.RotateLeft: Icon get() = Icon("rotate_left")
actual val Icons.Filled.RotateRight: Icon get() = Icon("rotate_right")
actual val Icons.Filled.RoundaboutLeft: Icon get() = Icon("roundabout_left")
actual val Icons.Filled.RoundaboutRight: Icon get() = Icon("roundabout_right")
actual val Icons.Filled.RoundedCorner: Icon get() = Icon("rounded_corner")
actual val Icons.Filled.Route: Icon get() = Icon("route")
actual val Icons.Filled.Router: Icon get() = Icon("router")
actual val Icons.Filled.Rowing: Icon get() = Icon("rowing")
actual val Icons.Filled.RssFeed: Icon get() = Icon("rss_feed")
actual val Icons.Filled.Rsvp: Icon get() = Icon("rsvp")
actual val Icons.Filled.Rtt: Icon get() = Icon("rtt")
actual val Icons.Filled.Rule: Icon get() = Icon("rule")
actual val Icons.Filled.RuleFolder: Icon get() = Icon("rule_folder")
actual val Icons.Filled.RunCircle: Icon get() = Icon("run_circle")
actual val Icons.Filled.RunningWithErrors: Icon get() = Icon("running_with_errors")
actual val Icons.Filled.RvHookup: Icon get() = Icon("rv_hookup")
actual val Icons.Filled.SafetyCheck: Icon get() = Icon("safety_check")
actual val Icons.Filled.SafetyDivider: Icon get() = Icon("safety_divider")
actual val Icons.Filled.Sailing: Icon get() = Icon("sailing")
actual val Icons.Filled.Sanitizer: Icon get() = Icon("sanitizer")
actual val Icons.Filled.Satellite: Icon get() = Icon("satellite")
actual val Icons.Filled.SatelliteAlt: Icon get() = Icon("satellite_alt")
actual val Icons.Filled.Save: Icon get() = Icon("save")
actual val Icons.Filled.SaveAs: Icon get() = Icon("save_as")
actual val Icons.Filled.SavedSearch: Icon get() = Icon("saved_search")
actual val Icons.Filled.Savings: Icon get() = Icon("savings")
actual val Icons.Filled.Scale: Icon get() = Icon("scale")
actual val Icons.Filled.Scanner: Icon get() = Icon("scanner")
actual val Icons.Filled.ScatterPlot: Icon get() = Icon("scatter_plot")
actual val Icons.Filled.Schedule: Icon get() = Icon("schedule")
actual val Icons.Filled.ScheduleSend: Icon get() = Icon("schedule_send")
actual val Icons.Filled.Schema: Icon get() = Icon("schema")
actual val Icons.Filled.School: Icon get() = Icon("school")
actual val Icons.Filled.Science: Icon get() = Icon("science")
actual val Icons.Filled.Score: Icon get() = Icon("score")
actual val Icons.Filled.Scoreboard: Icon get() = Icon("scoreboard")
actual val Icons.Filled.ScreenRotationAlt: Icon get() = Icon("screen_rotation_alt")
actual val Icons.Filled.ScreenSearchDesktop: Icon get() = Icon("screen_search_desktop")
actual val Icons.Filled.ScreenShare: Icon get() = Icon("screen_share")
actual val Icons.Filled.Screenshot: Icon get() = Icon("screenshot")
actual val Icons.Filled.ScreenshotMonitor: Icon get() = Icon("screenshot_monitor")
actual val Icons.Filled.ScubaDiving: Icon get() = Icon("scuba_diving")
actual val Icons.Filled.Sd: Icon get() = Icon("sd")
actual val Icons.Filled.SdCard: Icon get() = Icon("sd_card")
actual val Icons.Filled.SdCardAlert: Icon get() = Icon("sd_card_alert")
actual val Icons.Filled.SearchOff: Icon get() = Icon("search_off")
actual val Icons.Filled.Security: Icon get() = Icon("security")
actual val Icons.Filled.Segment: Icon get() = Icon("segment")
actual val Icons.Filled.SelectAll: Icon get() = Icon("select_all")
actual val Icons.Filled.SelfImprovement: Icon get() = Icon("self_improvement")
actual val Icons.Filled.Sell: Icon get() = Icon("sell")
actual val Icons.Filled.SendAndArchive: Icon get() = Icon("send_and_archive")
actual val Icons.Filled.SendTimeExtension: Icon get() = Icon("send_time_extension")
actual val Icons.Filled.SensorDoor: Icon get() = Icon("sensor_door")
actual val Icons.Filled.SensorOccupied: Icon get() = Icon("sensor_occupied")
actual val Icons.Filled.SensorWindow: Icon get() = Icon("sensor_window")
actual val Icons.Filled.Sensors: Icon get() = Icon("sensors")
actual val Icons.Filled.SensorsOff: Icon get() = Icon("sensors_off")
actual val Icons.Filled.SentimentDissatisfied: Icon get() = Icon("sentiment_dissatisfied")
actual val Icons.Filled.SentimentNeutral: Icon get() = Icon("sentiment_neutral")
actual val Icons.Filled.SentimentSatisfied: Icon get() = Icon("sentiment_satisfied")
actual val Icons.Filled.SentimentVeryDissatisfied: Icon get() = Icon("sentiment_very_dissatisfied")
actual val Icons.Filled.SentimentVerySatisfied: Icon get() = Icon("sentiment_very_satisfied")
actual val Icons.Filled.SetMeal: Icon get() = Icon("set_meal")
actual val Icons.Filled.SettingsAccessibility: Icon get() = Icon("settings_accessibility")
actual val Icons.Filled.SettingsApplications: Icon get() = Icon("settings_applications")
actual val Icons.Filled.SettingsBackupRestore: Icon get() = Icon("settings_backup_restore")
actual val Icons.Filled.SettingsBluetooth: Icon get() = Icon("settings_bluetooth")
actual val Icons.Filled.SettingsBrightness: Icon get() = Icon("settings_brightness")
actual val Icons.Filled.SettingsEthernet: Icon get() = Icon("settings_ethernet")
actual val Icons.Filled.SettingsInputAntenna: Icon get() = Icon("settings_input_antenna")
actual val Icons.Filled.SettingsInputComponent: Icon get() = Icon("settings_input_component")
actual val Icons.Filled.SettingsInputHdmi: Icon get() = Icon("settings_input_hdmi")
actual val Icons.Filled.SettingsInputSvideo: Icon get() = Icon("settings_input_svideo")
actual val Icons.Filled.SettingsOverscan: Icon get() = Icon("settings_overscan")
actual val Icons.Filled.SettingsPhone: Icon get() = Icon("settings_phone")
actual val Icons.Filled.SettingsPower: Icon get() = Icon("settings_power")
actual val Icons.Filled.SettingsRemote: Icon get() = Icon("settings_remote")
actual val Icons.Filled.SettingsSuggest: Icon get() = Icon("settings_suggest")
actual val Icons.Filled.SettingsSystemDaydream: Icon get() = Icon("settings_system_daydream")
actual val Icons.Filled.SettingsVoice: Icon get() = Icon("settings_voice")
actual val Icons.Filled.SevereCold: Icon get() = Icon("severe_cold")
actual val Icons.Filled.ShapeLine: Icon get() = Icon("shape_line")
actual val Icons.Filled.ShareLocation: Icon get() = Icon("share_location")
actual val Icons.Filled.Shield: Icon get() = Icon("shield")
actual val Icons.Filled.ShieldMoon: Icon get() = Icon("shield_moon")
actual val Icons.Filled.Shop: Icon get() = Icon("shop")
actual val Icons.Filled.ShopTwo: Icon get() = Icon("shop_two")
actual val Icons.Filled.ShoppingBag: Icon get() = Icon("shopping_bag")
actual val Icons.Filled.ShoppingBasket: Icon get() = Icon("shopping_basket")
actual val Icons.Filled.ShoppingCartCheckout: Icon get() = Icon("shopping_cart_checkout")
actual val Icons.Filled.ShortText: Icon get() = Icon("short_text")
actual val Icons.Filled.ShowChart: Icon get() = Icon("show_chart")
actual val Icons.Filled.Shower: Icon get() = Icon("shower")
actual val Icons.Filled.Shuffle: Icon get() = Icon("shuffle")
actual val Icons.Filled.ShuffleOn: Icon get() = Icon("shuffle_on")
actual val Icons.Filled.ShutterSpeed: Icon get() = Icon("shutter_speed")
actual val Icons.Filled.Sick: Icon get() = Icon("sick")
actual val Icons.Filled.SignLanguage: Icon get() = Icon("sign_language")
actual val Icons.Filled.SignalCellular0Bar: Icon get() = Icon("signal_cellular_0_bar")
actual val Icons.Filled.SignalCellular4Bar: Icon get() = Icon("signal_cellular_4_bar")
actual val Icons.Filled.SignalCellularAlt: Icon get() = Icon("signal_cellular_alt")
actual val Icons.Filled.SignalCellularAlt1Bar: Icon get() = Icon("signal_cellular_alt_1_bar")
actual val Icons.Filled.SignalCellularAlt2Bar: Icon get() = Icon("signal_cellular_alt_2_bar")
actual val Icons.Filled.SignalCellularConnectedNoInternet0Bar: Icon get() = Icon("signal_cellular_connected_no_internet_0_bar")
actual val Icons.Filled.SignalCellularConnectedNoInternet4Bar: Icon get() = Icon("signal_cellular_connected_no_internet_4_bar")
actual val Icons.Filled.SignalCellularNodata: Icon get() = Icon("signal_cellular_nodata")
actual val Icons.Filled.SignalCellularNull: Icon get() = Icon("signal_cellular_null")
actual val Icons.Filled.SignalCellularOff: Icon get() = Icon("signal_cellular_off")
actual val Icons.Filled.SignalWifi0Bar: Icon get() = Icon("signal_wifi_0_bar")
actual val Icons.Filled.SignalWifi4Bar: Icon get() = Icon("signal_wifi_4_bar")
actual val Icons.Filled.SignalWifiBad: Icon get() = Icon("signal_wifi_bad")
actual val Icons.Filled.SignalWifiOff: Icon get() = Icon("signal_wifi_off")
actual val Icons.Filled.SignalWifiStatusbarNull: Icon get() = Icon("signal_wifi_statusbar_null")
actual val Icons.Filled.Signpost: Icon get() = Icon("signpost")
actual val Icons.Filled.SimCard: Icon get() = Icon("sim_card")
actual val Icons.Filled.SimCardDownload: Icon get() = Icon("sim_card_download")
actual val Icons.Filled.SingleBed: Icon get() = Icon("single_bed")
actual val Icons.Filled.Sip: Icon get() = Icon("sip")
actual val Icons.Filled.Skateboarding: Icon get() = Icon("skateboarding")
actual val Icons.Filled.SkipNext: Icon get() = Icon("skip_next")
actual val Icons.Filled.SkipPrevious: Icon get() = Icon("skip_previous")
actual val Icons.Filled.Sledding: Icon get() = Icon("sledding")
actual val Icons.Filled.Slideshow: Icon get() = Icon("slideshow")
actual val Icons.Filled.SlowMotionVideo: Icon get() = Icon("slow_motion_video")
actual val Icons.Filled.SmartButton: Icon get() = Icon("smart_button")
actual val Icons.Filled.SmartDisplay: Icon get() = Icon("smart_display")
actual val Icons.Filled.SmartToy: Icon get() = Icon("smart_toy")
actual val Icons.Filled.SmokeFree: Icon get() = Icon("smoke_free")
actual val Icons.Filled.SmokingRooms: Icon get() = Icon("smoking_rooms")
actual val Icons.Filled.Sms: Icon get() = Icon("sms")
actual val Icons.Filled.SmsFailed: Icon get() = Icon("sms_failed")
actual val Icons.Filled.SnippetFolder: Icon get() = Icon("snippet_folder")
actual val Icons.Filled.Snooze: Icon get() = Icon("snooze")
actual val Icons.Filled.Snowboarding: Icon get() = Icon("snowboarding")
actual val Icons.Filled.Snowmobile: Icon get() = Icon("snowmobile")
actual val Icons.Filled.Snowshoeing: Icon get() = Icon("snowshoeing")
actual val Icons.Filled.Soap: Icon get() = Icon("soap")
actual val Icons.Filled.SocialDistance: Icon get() = Icon("social_distance")
actual val Icons.Filled.SolarPower: Icon get() = Icon("solar_power")
actual val Icons.Filled.Sort: Icon get() = Icon("sort")
actual val Icons.Filled.SortByAlpha: Icon get() = Icon("sort_by_alpha")
actual val Icons.Filled.Sos: Icon get() = Icon("sos")
actual val Icons.Filled.SoupKitchen: Icon get() = Icon("soup_kitchen")
actual val Icons.Filled.South: Icon get() = Icon("south")
actual val Icons.Filled.SouthAmerica: Icon get() = Icon("south_america")
actual val Icons.Filled.SouthEast: Icon get() = Icon("south_east")
actual val Icons.Filled.SouthWest: Icon get() = Icon("south_west")
actual val Icons.Filled.Spa: Icon get() = Icon("spa")
actual val Icons.Filled.SpaceBar: Icon get() = Icon("space_bar")
actual val Icons.Filled.SpaceDashboard: Icon get() = Icon("space_dashboard")
actual val Icons.Filled.SpatialAudio: Icon get() = Icon("spatial_audio")
actual val Icons.Filled.SpatialAudioOff: Icon get() = Icon("spatial_audio_off")
actual val Icons.Filled.SpatialTracking: Icon get() = Icon("spatial_tracking")
actual val Icons.Filled.Speaker: Icon get() = Icon("speaker")
actual val Icons.Filled.SpeakerGroup: Icon get() = Icon("speaker_group")
actual val Icons.Filled.SpeakerNotes: Icon get() = Icon("speaker_notes")
actual val Icons.Filled.SpeakerNotesOff: Icon get() = Icon("speaker_notes_off")
actual val Icons.Filled.SpeakerPhone: Icon get() = Icon("speaker_phone")
actual val Icons.Filled.Speed: Icon get() = Icon("speed")
actual val Icons.Filled.Spellcheck: Icon get() = Icon("spellcheck")
actual val Icons.Filled.Splitscreen: Icon get() = Icon("splitscreen")
actual val Icons.Filled.Spoke: Icon get() = Icon("spoke")
actual val Icons.Filled.Sports: Icon get() = Icon("sports")
actual val Icons.Filled.SportsBar: Icon get() = Icon("sports_bar")
actual val Icons.Filled.SportsBaseball: Icon get() = Icon("sports_baseball")
actual val Icons.Filled.SportsBasketball: Icon get() = Icon("sports_basketball")
actual val Icons.Filled.SportsCricket: Icon get() = Icon("sports_cricket")
actual val Icons.Filled.SportsEsports: Icon get() = Icon("sports_esports")
actual val Icons.Filled.SportsFootball: Icon get() = Icon("sports_football")
actual val Icons.Filled.SportsGolf: Icon get() = Icon("sports_golf")
actual val Icons.Filled.SportsGymnastics: Icon get() = Icon("sports_gymnastics")
actual val Icons.Filled.SportsHandball: Icon get() = Icon("sports_handball")
actual val Icons.Filled.SportsHockey: Icon get() = Icon("sports_hockey")
actual val Icons.Filled.SportsKabaddi: Icon get() = Icon("sports_kabaddi")
actual val Icons.Filled.SportsMartialArts: Icon get() = Icon("sports_martial_arts")
actual val Icons.Filled.SportsMma: Icon get() = Icon("sports_mma")
actual val Icons.Filled.SportsMotorsports: Icon get() = Icon("sports_motorsports")
actual val Icons.Filled.SportsRugby: Icon get() = Icon("sports_rugby")
actual val Icons.Filled.SportsScore: Icon get() = Icon("sports_score")
actual val Icons.Filled.SportsSoccer: Icon get() = Icon("sports_soccer")
actual val Icons.Filled.SportsTennis: Icon get() = Icon("sports_tennis")
actual val Icons.Filled.SportsVolleyball: Icon get() = Icon("sports_volleyball")
actual val Icons.Filled.Square: Icon get() = Icon("square")
actual val Icons.Filled.SquareFoot: Icon get() = Icon("square_foot")
actual val Icons.Filled.SsidChart: Icon get() = Icon("ssid_chart")
actual val Icons.Filled.StackedBarChart: Icon get() = Icon("stacked_bar_chart")
actual val Icons.Filled.StackedLineChart: Icon get() = Icon("stacked_line_chart")
actual val Icons.Filled.Stadium: Icon get() = Icon("stadium")
actual val Icons.Filled.Stairs: Icon get() = Icon("stairs")
actual val Icons.Filled.StarHalf: Icon get() = Icon("star_half")
actual val Icons.Filled.StarRate: Icon get() = Icon("star_rate")
actual val Icons.Filled.Stars: Icon get() = Icon("stars")
actual val Icons.Filled.Start: Icon get() = Icon("start")
actual val Icons.Filled.StickyNote2: Icon get() = Icon("sticky_note_2")
actual val Icons.Filled.Stop: Icon get() = Icon("stop")
actual val Icons.Filled.StopCircle: Icon get() = Icon("stop_circle")
actual val Icons.Filled.StopScreenShare: Icon get() = Icon("stop_screen_share")
actual val Icons.Filled.Storage: Icon get() = Icon("storage")
actual val Icons.Filled.Store: Icon get() = Icon("store")
actual val Icons.Filled.Storefront: Icon get() = Icon("storefront")
actual val Icons.Filled.Storm: Icon get() = Icon("storm")
actual val Icons.Filled.Straight: Icon get() = Icon("straight")
actual val Icons.Filled.Straighten: Icon get() = Icon("straighten")
actual val Icons.Filled.Stream: Icon get() = Icon("stream")
actual val Icons.Filled.Streetview: Icon get() = Icon("streetview")
actual val Icons.Filled.StrikethroughS: Icon get() = Icon("strikethrough_s")
actual val Icons.Filled.Stroller: Icon get() = Icon("stroller")
actual val Icons.Filled.Style: Icon get() = Icon("style")
actual val Icons.Filled.SubdirectoryArrowLeft: Icon get() = Icon("subdirectory_arrow_left")
actual val Icons.Filled.SubdirectoryArrowRight: Icon get() = Icon("subdirectory_arrow_right")
actual val Icons.Filled.Subject: Icon get() = Icon("subject")
actual val Icons.Filled.Subscript: Icon get() = Icon("subscript")
actual val Icons.Filled.Subscriptions: Icon get() = Icon("subscriptions")
actual val Icons.Filled.Subtitles: Icon get() = Icon("subtitles")
actual val Icons.Filled.SubtitlesOff: Icon get() = Icon("subtitles_off")
actual val Icons.Filled.Subway: Icon get() = Icon("subway")
actual val Icons.Filled.Summarize: Icon get() = Icon("summarize")
actual val Icons.Filled.Superscript: Icon get() = Icon("superscript")
actual val Icons.Filled.SupervisedUserCircle: Icon get() = Icon("supervised_user_circle")
actual val Icons.Filled.SupervisorAccount: Icon get() = Icon("supervisor_account")
actual val Icons.Filled.Support: Icon get() = Icon("support")
actual val Icons.Filled.SupportAgent: Icon get() = Icon("support_agent")
actual val Icons.Filled.Surfing: Icon get() = Icon("surfing")
actual val Icons.Filled.SurroundSound: Icon get() = Icon("surround_sound")
actual val Icons.Filled.SwapCalls: Icon get() = Icon("swap_calls")
actual val Icons.Filled.SwapHoriz: Icon get() = Icon("swap_horiz")
actual val Icons.Filled.SwapHorizontalCircle: Icon get() = Icon("swap_horizontal_circle")
actual val Icons.Filled.SwapVert: Icon get() = Icon("swap_vert")
actual val Icons.Filled.SwapVerticalCircle: Icon get() = Icon("swap_vertical_circle")
actual val Icons.Filled.Swipe: Icon get() = Icon("swipe")
actual val Icons.Filled.SwipeDown: Icon get() = Icon("swipe_down")
actual val Icons.Filled.SwipeDownAlt: Icon get() = Icon("swipe_down_alt")
actual val Icons.Filled.SwipeLeft: Icon get() = Icon("swipe_left")
actual val Icons.Filled.SwipeLeftAlt: Icon get() = Icon("swipe_left_alt")
actual val Icons.Filled.SwipeRight: Icon get() = Icon("swipe_right")
actual val Icons.Filled.SwipeRightAlt: Icon get() = Icon("swipe_right_alt")
actual val Icons.Filled.SwipeUp: Icon get() = Icon("swipe_up")
actual val Icons.Filled.SwipeUpAlt: Icon get() = Icon("swipe_up_alt")
actual val Icons.Filled.SwipeVertical: Icon get() = Icon("swipe_vertical")
actual val Icons.Filled.SwitchAccessShortcut: Icon get() = Icon("switch_access_shortcut")
actual val Icons.Filled.SwitchAccessShortcutAdd: Icon get() = Icon("switch_access_shortcut_add")
actual val Icons.Filled.SwitchAccount: Icon get() = Icon("switch_account")
actual val Icons.Filled.SwitchCamera: Icon get() = Icon("switch_camera")
actual val Icons.Filled.SwitchLeft: Icon get() = Icon("switch_left")
actual val Icons.Filled.SwitchRight: Icon get() = Icon("switch_right")
actual val Icons.Filled.SwitchVideo: Icon get() = Icon("switch_video")
actual val Icons.Filled.Synagogue: Icon get() = Icon("synagogue")
actual val Icons.Filled.Sync: Icon get() = Icon("sync")
actual val Icons.Filled.SyncAlt: Icon get() = Icon("sync_alt")
actual val Icons.Filled.SyncDisabled: Icon get() = Icon("sync_disabled")
actual val Icons.Filled.SyncLock: Icon get() = Icon("sync_lock")
actual val Icons.Filled.SyncProblem: Icon get() = Icon("sync_problem")
actual val Icons.Filled.SystemUpdateAlt: Icon get() = Icon("system_update_alt")
actual val Icons.Filled.Tab: Icon get() = Icon("tab")
actual val Icons.Filled.TabUnselected: Icon get() = Icon("tab_unselected")
actual val Icons.Filled.TableBar: Icon get() = Icon("table_bar")
actual val Icons.Filled.TableChart: Icon get() = Icon("table_chart")
actual val Icons.Filled.TableRestaurant: Icon get() = Icon("table_restaurant")
actual val Icons.Filled.TableRows: Icon get() = Icon("table_rows")
actual val Icons.Filled.TableView: Icon get() = Icon("table_view")
actual val Icons.Filled.Tablet: Icon get() = Icon("tablet")
actual val Icons.Filled.TabletAndroid: Icon get() = Icon("tablet_android")
actual val Icons.Filled.TabletMac: Icon get() = Icon("tablet_mac")
actual val Icons.Filled.Tag: Icon get() = Icon("tag")
actual val Icons.Filled.TakeoutDining: Icon get() = Icon("takeout_dining")
actual val Icons.Filled.Tapas: Icon get() = Icon("tapas")
actual val Icons.Filled.Task: Icon get() = Icon("task")
actual val Icons.Filled.TaskAlt: Icon get() = Icon("task_alt")
actual val Icons.Filled.TaxiAlert: Icon get() = Icon("taxi_alert")
actual val Icons.Filled.TempleBuddhist: Icon get() = Icon("temple_buddhist")
actual val Icons.Filled.TempleHindu: Icon get() = Icon("temple_hindu")
actual val Icons.Filled.Terminal: Icon get() = Icon("terminal")
actual val Icons.Filled.TextDecrease: Icon get() = Icon("text_decrease")
actual val Icons.Filled.TextFields: Icon get() = Icon("text_fields")
actual val Icons.Filled.TextFormat: Icon get() = Icon("text_format")
actual val Icons.Filled.TextIncrease: Icon get() = Icon("text_increase")
actual val Icons.Filled.TextRotateUp: Icon get() = Icon("text_rotate_up")
actual val Icons.Filled.TextRotateVertical: Icon get() = Icon("text_rotate_vertical")
actual val Icons.Filled.TextRotationAngledown: Icon get() = Icon("text_rotation_angledown")
actual val Icons.Filled.TextRotationAngleup: Icon get() = Icon("text_rotation_angleup")
actual val Icons.Filled.TextRotationDown: Icon get() = Icon("text_rotation_down")
actual val Icons.Filled.TextRotationNone: Icon get() = Icon("text_rotation_none")
actual val Icons.Filled.TextSnippet: Icon get() = Icon("text_snippet")
actual val Icons.Filled.Texture: Icon get() = Icon("texture")
actual val Icons.Filled.TheaterComedy: Icon get() = Icon("theater_comedy")
actual val Icons.Filled.Theaters: Icon get() = Icon("theaters")
actual val Icons.Filled.Thermostat: Icon get() = Icon("thermostat")
actual val Icons.Filled.ThermostatAuto: Icon get() = Icon("thermostat_auto")
actual val Icons.Filled.ThumbDown: Icon get() = Icon("thumb_down")
actual val Icons.Filled.ThumbsUpDown: Icon get() = Icon("thumbs_up_down")
actual val Icons.Filled.Thunderstorm: Icon get() = Icon("thunderstorm")
actual val Icons.Filled.Timelapse: Icon get() = Icon("timelapse")
actual val Icons.Filled.Timeline: Icon get() = Icon("timeline")
actual val Icons.Filled.Timer: Icon get() = Icon("timer")
actual val Icons.Filled.Timer10: Icon get() = Icon("timer_10")
actual val Icons.Filled.Timer10Select: Icon get() = Icon("timer_10_select")
actual val Icons.Filled.Timer3: Icon get() = Icon("timer_3")
actual val Icons.Filled.Timer3Select: Icon get() = Icon("timer_3_select")
actual val Icons.Filled.TimerOff: Icon get() = Icon("timer_off")
actual val Icons.Filled.TipsAndUpdates: Icon get() = Icon("tips_and_updates")
actual val Icons.Filled.TireRepair: Icon get() = Icon("tire_repair")
actual val Icons.Filled.Title: Icon get() = Icon("title")
actual val Icons.Filled.Toc: Icon get() = Icon("toc")
actual val Icons.Filled.Today: Icon get() = Icon("today")
actual val Icons.Filled.ToggleOff: Icon get() = Icon("toggle_off")
actual val Icons.Filled.ToggleOn: Icon get() = Icon("toggle_on")
actual val Icons.Filled.Token: Icon get() = Icon("token")
actual val Icons.Filled.Toll: Icon get() = Icon("toll")
actual val Icons.Filled.Tonality: Icon get() = Icon("tonality")
actual val Icons.Filled.Topic: Icon get() = Icon("topic")
actual val Icons.Filled.Tornado: Icon get() = Icon("tornado")
actual val Icons.Filled.TouchApp: Icon get() = Icon("touch_app")
actual val Icons.Filled.Tour: Icon get() = Icon("tour")
actual val Icons.Filled.Toys: Icon get() = Icon("toys")
actual val Icons.Filled.TrackChanges: Icon get() = Icon("track_changes")
actual val Icons.Filled.Traffic: Icon get() = Icon("traffic")
actual val Icons.Filled.Train: Icon get() = Icon("train")
actual val Icons.Filled.Tram: Icon get() = Icon("tram")
actual val Icons.Filled.Transcribe: Icon get() = Icon("transcribe")
actual val Icons.Filled.TransferWithinAStation: Icon get() = Icon("transfer_within_a_station")
actual val Icons.Filled.Transform: Icon get() = Icon("transform")
actual val Icons.Filled.Transgender: Icon get() = Icon("transgender")
actual val Icons.Filled.TransitEnterexit: Icon get() = Icon("transit_enterexit")
actual val Icons.Filled.Translate: Icon get() = Icon("translate")
actual val Icons.Filled.TravelExplore: Icon get() = Icon("travel_explore")
actual val Icons.Filled.TrendingDown: Icon get() = Icon("trending_down")
actual val Icons.Filled.TrendingFlat: Icon get() = Icon("trending_flat")
actual val Icons.Filled.TrendingUp: Icon get() = Icon("trending_up")
actual val Icons.Filled.TripOrigin: Icon get() = Icon("trip_origin")
actual val Icons.Filled.Troubleshoot: Icon get() = Icon("troubleshoot")
actual val Icons.Filled.Tsunami: Icon get() = Icon("tsunami")
actual val Icons.Filled.Tty: Icon get() = Icon("tty")
actual val Icons.Filled.Tune: Icon get() = Icon("tune")
actual val Icons.Filled.TurnLeft: Icon get() = Icon("turn_left")
actual val Icons.Filled.TurnRight: Icon get() = Icon("turn_right")
actual val Icons.Filled.TurnSharpLeft: Icon get() = Icon("turn_sharp_left")
actual val Icons.Filled.TurnSharpRight: Icon get() = Icon("turn_sharp_right")
actual val Icons.Filled.TurnSlightLeft: Icon get() = Icon("turn_slight_left")
actual val Icons.Filled.TurnSlightRight: Icon get() = Icon("turn_slight_right")
actual val Icons.Filled.Tv: Icon get() = Icon("tv")
actual val Icons.Filled.TvOff: Icon get() = Icon("tv_off")
actual val Icons.Filled.TwoWheeler: Icon get() = Icon("two_wheeler")
actual val Icons.Filled.TypeSpecimen: Icon get() = Icon("type_specimen")
actual val Icons.Filled.UTurnLeft: Icon get() = Icon("u_turn_left")
actual val Icons.Filled.UTurnRight: Icon get() = Icon("u_turn_right")
actual val Icons.Filled.Umbrella: Icon get() = Icon("umbrella")
actual val Icons.Filled.Unarchive: Icon get() = Icon("unarchive")
actual val Icons.Filled.Undo: Icon get() = Icon("undo")
actual val Icons.Filled.UnfoldLess: Icon get() = Icon("unfold_less")
actual val Icons.Filled.UnfoldLessDouble: Icon get() = Icon("unfold_less_double")
actual val Icons.Filled.UnfoldMore: Icon get() = Icon("unfold_more")
actual val Icons.Filled.UnfoldMoreDouble: Icon get() = Icon("unfold_more_double")
actual val Icons.Filled.Unpublished: Icon get() = Icon("unpublished")
actual val Icons.Filled.Unsubscribe: Icon get() = Icon("unsubscribe")
actual val Icons.Filled.Upcoming: Icon get() = Icon("upcoming")
actual val Icons.Filled.Update: Icon get() = Icon("update")
actual val Icons.Filled.UpdateDisabled: Icon get() = Icon("update_disabled")
actual val Icons.Filled.Upgrade: Icon get() = Icon("upgrade")
actual val Icons.Filled.Upload: Icon get() = Icon("upload")
actual val Icons.Filled.UploadFile: Icon get() = Icon("upload_file")
actual val Icons.Filled.Usb: Icon get() = Icon("usb")
actual val Icons.Filled.UsbOff: Icon get() = Icon("usb_off")
actual val Icons.Filled.Vaccines: Icon get() = Icon("vaccines")
actual val Icons.Filled.VapeFree: Icon get() = Icon("vape_free")
actual val Icons.Filled.VapingRooms: Icon get() = Icon("vaping_rooms")
actual val Icons.Filled.Verified: Icon get() = Icon("verified")
actual val Icons.Filled.VerifiedUser: Icon get() = Icon("verified_user")
actual val Icons.Filled.VerticalAlignBottom: Icon get() = Icon("vertical_align_bottom")
actual val Icons.Filled.VerticalAlignCenter: Icon get() = Icon("vertical_align_center")
actual val Icons.Filled.VerticalAlignTop: Icon get() = Icon("vertical_align_top")
actual val Icons.Filled.VerticalDistribute: Icon get() = Icon("vertical_distribute")
actual val Icons.Filled.VerticalShades: Icon get() = Icon("vertical_shades")
actual val Icons.Filled.VerticalShadesClosed: Icon get() = Icon("vertical_shades_closed")
actual val Icons.Filled.VerticalSplit: Icon get() = Icon("vertical_split")
actual val Icons.Filled.VideoCall: Icon get() = Icon("video_call")
actual val Icons.Filled.VideoCameraBack: Icon get() = Icon("video_camera_back")
actual val Icons.Filled.VideoCameraFront: Icon get() = Icon("video_camera_front")
actual val Icons.Filled.VideoChat: Icon get() = Icon("video_chat")
actual val Icons.Filled.VideoFile: Icon get() = Icon("video_file")
actual val Icons.Filled.VideoLabel: Icon get() = Icon("video_label")
actual val Icons.Filled.VideoLibrary: Icon get() = Icon("video_library")
actual val Icons.Filled.VideoSettings: Icon get() = Icon("video_settings")
actual val Icons.Filled.VideoStable: Icon get() = Icon("video_stable")
actual val Icons.Filled.Videocam: Icon get() = Icon("videocam")
actual val Icons.Filled.VideocamOff: Icon get() = Icon("videocam_off")
actual val Icons.Filled.VideogameAsset: Icon get() = Icon("videogame_asset")
actual val Icons.Filled.VideogameAssetOff: Icon get() = Icon("videogame_asset_off")
actual val Icons.Filled.ViewAgenda: Icon get() = Icon("view_agenda")
actual val Icons.Filled.ViewArray: Icon get() = Icon("view_array")
actual val Icons.Filled.ViewCarousel: Icon get() = Icon("view_carousel")
actual val Icons.Filled.ViewColumn: Icon get() = Icon("view_column")
actual val Icons.Filled.ViewComfy: Icon get() = Icon("view_comfy")
actual val Icons.Filled.ViewComfyAlt: Icon get() = Icon("view_comfy_alt")
actual val Icons.Filled.ViewCompact: Icon get() = Icon("view_compact")
actual val Icons.Filled.ViewCompactAlt: Icon get() = Icon("view_compact_alt")
actual val Icons.Filled.ViewCozy: Icon get() = Icon("view_cozy")
actual val Icons.Filled.ViewDay: Icon get() = Icon("view_day")
actual val Icons.Filled.ViewHeadline: Icon get() = Icon("view_headline")
actual val Icons.Filled.ViewInAr: Icon get() = Icon("view_in_ar")
actual val Icons.Filled.ViewKanban: Icon get() = Icon("view_kanban")
actual val Icons.Filled.ViewList: Icon get() = Icon("view_list")
actual val Icons.Filled.ViewModule: Icon get() = Icon("view_module")
actual val Icons.Filled.ViewQuilt: Icon get() = Icon("view_quilt")
actual val Icons.Filled.ViewSidebar: Icon get() = Icon("view_sidebar")
actual val Icons.Filled.ViewStream: Icon get() = Icon("view_stream")
actual val Icons.Filled.ViewTimeline: Icon get() = Icon("view_timeline")
actual val Icons.Filled.ViewWeek: Icon get() = Icon("view_week")
actual val Icons.Filled.Vignette: Icon get() = Icon("vignette")
actual val Icons.Filled.Villa: Icon get() = Icon("villa")
actual val Icons.Filled.Visibility: Icon get() = Icon("visibility")
actual val Icons.Filled.VisibilityOff: Icon get() = Icon("visibility_off")
actual val Icons.Filled.VoiceChat: Icon get() = Icon("voice_chat")
actual val Icons.Filled.VoiceOverOff: Icon get() = Icon("voice_over_off")
actual val Icons.Filled.Voicemail: Icon get() = Icon("voicemail")
actual val Icons.Filled.Volcano: Icon get() = Icon("volcano")
actual val Icons.Filled.VolumeDown: Icon get() = Icon("volume_down")
actual val Icons.Filled.VolumeMute: Icon get() = Icon("volume_mute")
actual val Icons.Filled.VolumeOff: Icon get() = Icon("volume_off")
actual val Icons.Filled.VolumeUp: Icon get() = Icon("volume_up")
actual val Icons.Filled.VolunteerActivism: Icon get() = Icon("volunteer_activism")
actual val Icons.Filled.VpnKey: Icon get() = Icon("vpn_key")
actual val Icons.Filled.VpnKeyOff: Icon get() = Icon("vpn_key_off")
actual val Icons.Filled.VpnLock: Icon get() = Icon("vpn_lock")
actual val Icons.Filled.Vrpano: Icon get() = Icon("vrpano")
actual val Icons.Filled.Wallet: Icon get() = Icon("wallet")
actual val Icons.Filled.Wallpaper: Icon get() = Icon("wallpaper")
actual val Icons.Filled.Warehouse: Icon get() = Icon("warehouse")
actual val Icons.Filled.Wash: Icon get() = Icon("wash")
actual val Icons.Filled.Watch: Icon get() = Icon("watch")
actual val Icons.Filled.WatchOff: Icon get() = Icon("watch_off")
actual val Icons.Filled.Water: Icon get() = Icon("water")
actual val Icons.Filled.WaterDamage: Icon get() = Icon("water_damage")
actual val Icons.Filled.WaterDrop: Icon get() = Icon("water_drop")
actual val Icons.Filled.WaterfallChart: Icon get() = Icon("waterfall_chart")
actual val Icons.Filled.Waves: Icon get() = Icon("waves")
actual val Icons.Filled.WavingHand: Icon get() = Icon("waving_hand")
actual val Icons.Filled.WbAuto: Icon get() = Icon("wb_auto")
actual val Icons.Filled.WbIncandescent: Icon get() = Icon("wb_incandescent")
actual val Icons.Filled.WbIridescent: Icon get() = Icon("wb_iridescent")
actual val Icons.Filled.WbShade: Icon get() = Icon("wb_shade")
actual val Icons.Filled.WbSunny: Icon get() = Icon("wb_sunny")
actual val Icons.Filled.WbTwilight: Icon get() = Icon("wb_twilight")
actual val Icons.Filled.Wc: Icon get() = Icon("wc")
actual val Icons.Filled.Web: Icon get() = Icon("web")
actual val Icons.Filled.WebAsset: Icon get() = Icon("web_asset")
actual val Icons.Filled.WebAssetOff: Icon get() = Icon("web_asset_off")
actual val Icons.Filled.WebStories: Icon get() = Icon("web_stories")
actual val Icons.Filled.Webhook: Icon get() = Icon("webhook")
actual val Icons.Filled.Weekend: Icon get() = Icon("weekend")
actual val Icons.Filled.West: Icon get() = Icon("west")
actual val Icons.Filled.Whatshot: Icon get() = Icon("whatshot")
actual val Icons.Filled.WheelchairPickup: Icon get() = Icon("wheelchair_pickup")
actual val Icons.Filled.WhereToVote: Icon get() = Icon("where_to_vote")
actual val Icons.Filled.Widgets: Icon get() = Icon("widgets")
actual val Icons.Filled.WidthFull: Icon get() = Icon("width_full")
actual val Icons.Filled.WidthNormal: Icon get() = Icon("width_normal")
actual val Icons.Filled.WidthWide: Icon get() = Icon("width_wide")
actual val Icons.Filled.Wifi: Icon get() = Icon("wifi")
actual val Icons.Filled.Wifi1Bar: Icon get() = Icon("wifi_1_bar")
actual val Icons.Filled.Wifi2Bar: Icon get() = Icon("wifi_2_bar")
actual val Icons.Filled.WifiCalling: Icon get() = Icon("wifi_calling")
actual val Icons.Filled.WifiChannel: Icon get() = Icon("wifi_channel")
actual val Icons.Filled.WifiFind: Icon get() = Icon("wifi_find")
actual val Icons.Filled.WifiLock: Icon get() = Icon("wifi_lock")
actual val Icons.Filled.WifiOff: Icon get() = Icon("wifi_off")
actual val Icons.Filled.WifiPassword: Icon get() = Icon("wifi_password")
actual val Icons.Filled.WifiProtectedSetup: Icon get() = Icon("wifi_protected_setup")
actual val Icons.Filled.WifiTethering: Icon get() = Icon("wifi_tethering")
actual val Icons.Filled.WifiTetheringError: Icon get() = Icon("wifi_tethering_error")
actual val Icons.Filled.WifiTetheringOff: Icon get() = Icon("wifi_tethering_off")
actual val Icons.Filled.WindPower: Icon get() = Icon("wind_power")
actual val Icons.Filled.Window: Icon get() = Icon("window")
actual val Icons.Filled.WineBar: Icon get() = Icon("wine_bar")
actual val Icons.Filled.Woman: Icon get() = Icon("woman")
actual val Icons.Filled.Woman2: Icon get() = Icon("woman_2")
actual val Icons.Filled.Work: Icon get() = Icon("work")
actual val Icons.Filled.WorkHistory: Icon get() = Icon("work_history")
actual val Icons.Filled.WorkOff: Icon get() = Icon("work_off")
actual val Icons.Filled.WorkspacePremium: Icon get() = Icon("workspace_premium")
actual val Icons.Filled.Workspaces: Icon get() = Icon("workspaces")
actual val Icons.Filled.WrapText: Icon get() = Icon("wrap_text")
actual val Icons.Filled.WrongLocation: Icon get() = Icon("wrong_location")
actual val Icons.Filled.Wysiwyg: Icon get() = Icon("wysiwyg")
actual val Icons.Filled.Yard: Icon get() = Icon("yard")
actual val Icons.Filled.YoutubeSearchedFor: Icon get() = Icon("youtube_searched_for")
actual val Icons.Filled.ZoomIn: Icon get() = Icon("zoom_in")
actual val Icons.Filled.ZoomInMap: Icon get() = Icon("zoom_in_map")
actual val Icons.Filled.ZoomOut: Icon get() = Icon("zoom_out")
actual val Icons.Filled.ZoomOutMap: Icon get() = Icon("zoom_out_map")
actual val Icons.Filled._10k: Icon get() = Icon("10k")
actual val Icons.Filled._10mp: Icon get() = Icon("10mp")
actual val Icons.Filled._11mp: Icon get() = Icon("11mp")
actual val Icons.Filled._123: Icon get() = Icon("123")
actual val Icons.Filled._12mp: Icon get() = Icon("12mp")
actual val Icons.Filled._13mp: Icon get() = Icon("13mp")
actual val Icons.Filled._14mp: Icon get() = Icon("14mp")
actual val Icons.Filled._15mp: Icon get() = Icon("15mp")
actual val Icons.Filled._16mp: Icon get() = Icon("16mp")
actual val Icons.Filled._17mp: Icon get() = Icon("17mp")
actual val Icons.Filled._18UpRating: Icon get() = Icon("18_up_rating")
actual val Icons.Filled._18mp: Icon get() = Icon("18mp")
actual val Icons.Filled._19mp: Icon get() = Icon("19mp")
actual val Icons.Filled._1k: Icon get() = Icon("1k")
actual val Icons.Filled._1kPlus: Icon get() = Icon("1k_plus")
actual val Icons.Filled._1xMobiledata: Icon get() = Icon("1x_mobiledata")
actual val Icons.Filled._20mp: Icon get() = Icon("20mp")
actual val Icons.Filled._21mp: Icon get() = Icon("21mp")
actual val Icons.Filled._22mp: Icon get() = Icon("22mp")
actual val Icons.Filled._23mp: Icon get() = Icon("23mp")
actual val Icons.Filled._24mp: Icon get() = Icon("24mp")
actual val Icons.Filled._2k: Icon get() = Icon("2k")
actual val Icons.Filled._2kPlus: Icon get() = Icon("2k_plus")
actual val Icons.Filled._2mp: Icon get() = Icon("2mp")
actual val Icons.Filled._30fps: Icon get() = Icon("30fps")
actual val Icons.Filled._30fpsSelect: Icon get() = Icon("30fps_select")
actual val Icons.Filled._360: Icon get() = Icon("360")
actual val Icons.Filled._3dRotation: Icon get() = Icon("3d_rotation")
actual val Icons.Filled._3gMobiledata: Icon get() = Icon("3g_mobiledata")
actual val Icons.Filled._3k: Icon get() = Icon("3k")
actual val Icons.Filled._3kPlus: Icon get() = Icon("3k_plus")
actual val Icons.Filled._3mp: Icon get() = Icon("3mp")
actual val Icons.Filled._3p: Icon get() = Icon("3p")
actual val Icons.Filled._4gMobiledata: Icon get() = Icon("4g_mobiledata")
actual val Icons.Filled._4gPlusMobiledata: Icon get() = Icon("4g_plus_mobiledata")
actual val Icons.Filled._4k: Icon get() = Icon("4k")
actual val Icons.Filled._4kPlus: Icon get() = Icon("4k_plus")
actual val Icons.Filled._4mp: Icon get() = Icon("4mp")
actual val Icons.Filled._5g: Icon get() = Icon("5g")
actual val Icons.Filled._5k: Icon get() = Icon("5k")
actual val Icons.Filled._5kPlus: Icon get() = Icon("5k_plus")
actual val Icons.Filled._5mp: Icon get() = Icon("5mp")
actual val Icons.Filled._60fps: Icon get() = Icon("60fps")
actual val Icons.Filled._60fpsSelect: Icon get() = Icon("60fps_select")
actual val Icons.Filled._6FtApart: Icon get() = Icon("6_ft_apart")
actual val Icons.Filled._6k: Icon get() = Icon("6k")
actual val Icons.Filled._6kPlus: Icon get() = Icon("6k_plus")
actual val Icons.Filled._6mp: Icon get() = Icon("6mp")
actual val Icons.Filled._7k: Icon get() = Icon("7k")
actual val Icons.Filled._7kPlus: Icon get() = Icon("7k_plus")
actual val Icons.Filled._7mp: Icon get() = Icon("7mp")
actual val Icons.Filled._8k: Icon get() = Icon("8k")
actual val Icons.Filled._8kPlus: Icon get() = Icon("8k_plus")
actual val Icons.Filled._8mp: Icon get() = Icon("8mp")
actual val Icons.Filled._9k: Icon get() = Icon("9k")
actual val Icons.Filled._9kPlus: Icon get() = Icon("9k_plus")
actual val Icons.Filled._9mp: Icon get() = Icon("9mp")
